import { useState, useEffect, useCallback } from "react";
import { supabase } from "./supabase";
import { LogOut, Plus, Trash2, Shield, Users, FolderOpen, X, Check, Folder, Image, FileText, Play, Eye, EyeOff, Lock, UploadCloud, ArrowLeft, Download, ChevronLeft, ChevronRight, Menu, Pencil } from "lucide-react";

const LOGO = "data:image/png;base64,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";

/* ══════════════════════════════════════════════════════════════════
   APPLE DESIGN SYSTEM
   Dizajnirao kao senior Apple designer: tišina, jasnoća, dubina
══════════════════════════════════════════════════════════════════ */

const C = {
  bg:         "#FBFBFD",   // Apple canvas
  surface:    "#FFFFFF",   // Cards
  nav:        "#000000",   // Navigation
  text:       "#1D1D1F",   // Primary label
  textMuted:  "#86868B",   // Secondary label
  textFaint:  "#6E6E73",   // Tertiary label
  border:     "#D2D2D7",   // Divider
  borderSoft: "#E8E8ED",   // Soft divider
  hairline:   "#F5F5F7",   // Hairline
  btnPrimary: "#1D1D1F",
  btnHover:   "#000000",
  danger:     "#FF3B30",
  dangerBg:   "#FFF0EF",
};

const F = "-apple-system,BlinkMacSystemFont,'SF Pro Display','SF Pro Text','Helvetica Neue',Arial,sans-serif";
const PER = 100;
const FILE_API_BASE = (process.env.REACT_APP_FILES_API_URL || "https://files-api.sigma-adria.com").replace(/\/$/, "");

const buildServerDownloadUrl = (serverPath, name) => `${FILE_API_BASE}/download.php?path=${encodeURIComponent(serverPath)}&name=${encodeURIComponent(name || "download")}`;

const getSupabaseAccessToken = async () => {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw new Error("Ne mogu provjeriti prijavu korisnika.");
  const token = data?.session?.access_token;
  if (!token) throw new Error("Niste prijavljeni. Molim osvježite stranicu i prijavite se ponovno.");
  return token;
};

const downloadBlobFromUrl = async (url, filename = "download") => {
  if (!url || url === "#") throw new Error("Datoteka nema valjani link za preuzimanje.");

  const token = await getSupabaseAccessToken();

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Preuzimanje nije uspjelo.");

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
};


// Čisti naziv datoteke prije slanja na server.
// Datoteke s hrvatskim slovima (č ć š ž đ), znakom + i sličnim znakovima server
// kasnije ne može pouzdano pronaći, pa se slika ne prikaže. Zato naziv pretvaramo
// u siguran oblik: "FOTO_ŽUNIĆ+.jpg" -> "FOTO_ZUNIC.jpg".
const DIACRITIC_MAP = {
  "č": "c", "ć": "c", "š": "s", "ž": "z", "đ": "d",
  "Č": "C", "Ć": "C", "Š": "S", "Ž": "Z", "Đ": "D",
};

const sanitizeUploadName = (rawName) => {
  const fullName = String(rawName || "");
  const dotIndex = fullName.lastIndexOf(".");
  const hasExt = dotIndex > 0;

  const cleanPart = (part) => {
    let out = String(part || "");
    // macOS zapisuje "Ž" kao slovo + kvačicu odvojeno - prvo ih spajamo.
    try { out = out.normalize("NFC"); } catch (e) { /* stariji preglednik */ }
    out = out.replace(/[čćšžđČĆŠŽĐ]/g, ch => DIACRITIC_MAP[ch] || ch);
    // Skini preostale kvačice/naglaske (npr. é -> e).
    try { out = out.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); } catch (e) { /* stariji preglednik */ }
    out = out.replace(/[^A-Za-z0-9._-]/g, "_");
    out = out.replace(/_+/g, "_").replace(/^_+/, "").replace(/_+$/, "");
    return out;
  };

  let base = cleanPart(hasExt ? fullName.slice(0, dotIndex) : fullName);
  const ext = hasExt ? cleanPart(fullName.slice(dotIndex + 1)).toLowerCase() : "";

  if (!base) base = "datoteka";
  if (base.length > 100) base = base.slice(0, 100);

  return ext ? `${base}.${ext}` : base;
};

const uploadServerFile = async (folderId, file) => {
  const token = await getSupabaseAccessToken();

  const formData = new FormData();
  formData.append("folder_id", folderId);
  formData.append("file", file, sanitizeUploadName(file && file.name));
  formData.append("auth_token", token);

  const response = await fetch(`${FILE_API_BASE}/upload.php`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const text = await response.text();
  let payload = null;
  try {
    payload = JSON.parse(text);
  } catch {
    throw new Error(text || "Greška servera pri uploadu.");
  }

  if (!response.ok || !payload?.ok) {
    throw new Error(payload?.error || "Greška servera pri uploadu.");
  }

  return payload.file;
};

const deleteServerFile = async (serverPath) => {
  if (!serverPath) return;

  const token = await getSupabaseAccessToken();

  const formData = new FormData();
  formData.append("path", serverPath);
  formData.append("auth_token", token);

  const response = await fetch(`${FILE_API_BASE}/delete.php`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (response.status === 404) return;

  const text = await response.text();
  let payload = null;
  try {
    payload = JSON.parse(text);
  } catch {
    throw new Error(text || "Greška servera pri brisanju filea.");
  }

  if (!response.ok || !payload?.ok) {
    throw new Error(payload?.error || "Greška servera pri brisanju filea.");
  }
};


// Muted, sophisticated folder type colors — Apple-esque

const mimeToType = m => m.startsWith("image/")?"image":m.startsWith("video/")?"video":"document";

// Vraća ekstenziju datoteke iz imena (npr. "logo.eps" -> "eps")
const getFileExt = (name) => {
  const m = /\.([a-z0-9]+)$/i.exec(name || "");
  return m ? m[1].toLowerCase() : "";
};

// Formati koje WEB PREGLEDNIK može nacrtati kao sliku.
// EPS, AI, PSD, TIFF i sl. preglednik NE može prikazati pa za njih pokazujemo pločicu formata.
const BROWSER_IMAGE_EXTS = ["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "ico", "avif"];
const isBrowserDisplayable = (file) => BROWSER_IMAGE_EXTS.includes(getFileExt(file && file.name));

// Skrati predugačko ime datoteke u JEDAN red, ali zadrži nastavak.
// Npr. "SIGMA_Wordmark_White_RGB.jpg" -> "SIGMA_Wordmar…te_RGB.jpg"
const truncateMiddle = (name, head = 13, tail = 10) => {
  if (!name || name.length <= head + tail + 1) return name;
  return name.slice(0, head) + "…" + name.slice(name.length - tail);
};

// Vrati ISPRAVAN URL za prikaz/preuzimanje datoteke.
// Za datoteke na našem serveru URL se gradi iz server_path jer pohranjeni "url"
// u bazi može biti zastario (npr. stari Supabase link).
const resolveFileUrl = (file) => {
  if (file?.storage_provider === "server" && file?.server_path) {
    return buildServerDownloadUrl(file.server_path, file.original_name || file.name || "download");
  }
  return file?.url || "";
};

// Osvježi datoteku za prikaz: ispravan URL + ispravan tip prema nastavku imena
// (pohranjeni tip može biti pogrešan ako mime nije dobro zabilježen pri uploadu).
const IMAGE_FILE_EXTS = ["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "ico", "avif"];
const VIDEO_FILE_EXTS = ["mp4", "webm", "mov", "m4v", "ogv"];
const normalizeFileForDisplay = (file) => {
  const ext = getFileExt(file && file.name);
  let type = file && file.type;
  if (IMAGE_FILE_EXTS.includes(ext)) type = "image";
  else if (VIDEO_FILE_EXTS.includes(ext)) type = "video";
  return { ...file, type, url: resolveFileUrl(file) };
};


const getFolderFiles = (allFiles, folderId) => allFiles.filter(f => f.folder_id === folderId);

// Broji SVE datoteke u folderu, uključujući datoteke u svim podfolderima (rekurzivno)
const countFilesDeep = (allFiles, allFolders, folderId) => {
  let count = allFiles.filter(f => f.folder_id === folderId).length;
  const children = (allFolders || []).filter(f => f.parent_folder_id === folderId);
  for (const child of children) {
    count += countFilesDeep(allFiles, allFolders, child.id);
  }
  return count;
};

const getFolderContentMeta = (folderFiles) => {
  if (folderFiles.some(f => f.type === "image")) {
    return { Icon: Image, label: "Slike i sadržaj" };
  }
  if (folderFiles.some(f => f.type === "video")) {
    return { Icon: Play, label: "Video i sadržaj" };
  }
  if (folderFiles.some(f => f.type === "document")) {
    return { Icon: FileText, label: "Dokumenti" };
  }
  return { Icon: FolderOpen, label: "Folder" };
};

const getFolderPreview = (folderFiles) => {
  const firstImg = folderFiles.find(f => f.type === "image");
  if (firstImg?.url) return { kind: "image", url: firstImg.url };
  if (folderFiles.some(f => f.type === "video")) return { kind: "video" };
  if (folderFiles.some(f => f.type === "document")) return { kind: "document" };
  return { kind: "empty" };
};

// PROTECTED_IMAGE_PREVIEW_FIX_V5
// ADMIN_FOLDER_THUMBNAIL_AUTH_FIX_V6

// Neutralan prikaz DOK se slika učitava (da se ne pojavi greška prije slike).
function ImageLoading({ style = {} }) {
  const radius = style && style.borderRadius ? style.borderRadius : 12;
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      width: "100%", height: "100%", minWidth: 120, minHeight: 120,
      borderRadius: radius,
      background: "linear-gradient(160deg, #F1F3F8 0%, #E6EAF1 100%)",
    }}>
      <div style={{
        width: 26, height: 26, borderRadius: "50%",
        border: "2px solid rgba(99,102,241,.25)", borderTopColor: "#6366F1",
        animation: "spin .8s linear infinite",
      }}/>
    </div>
  );
}

function ProtectedImage({ src, alt = "", style = {}, className, fallback = null, ...props }) {
  const [resolvedSrc, setResolvedSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl = null;

    setResolvedSrc(null);
    setFailed(false);

    if (!src) {
      setFailed(true);
      return undefined;
    }

    const needsAuth = typeof src === "string" && src.includes("/download.php");

    if (!needsAuth) {
      setResolvedSrc(src);
      return undefined;
    }

    (async () => {
      try {
        const token = await getSupabaseAccessToken();
        const response = await fetch(src, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error("Image preview failed");
        }

        const blob = await response.blob();
        objectUrl = window.URL.createObjectURL(blob);

        if (active) {
          setResolvedSrc(objectUrl);
        }
      } catch {
        if (active) {
          setFailed(true);
        }
      }
    })();

    return () => {
      active = false;
      if (objectUrl) {
        window.URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  if (failed) {
    return fallback;
  }
  if (!resolvedSrc) {
    return <ImageLoading style={style} />;
  }

  return <img src={resolvedSrc} alt={alt} style={style} className={className} onError={() => setFailed(true)} {...props} />;
}

// Uredna pločica za formate koji se ne prikazuju kao slika (EPS, AI, PDF, video...).
// Pokazuje ikonu (ovisno o tipu) + oznaku formata umjesto slomljene slike.
function FileFormatPlaceholder({ name, kind = "image" }) {
  const ext = (getFileExt(name) || "FILE").toUpperCase();
  const Icon = kind === "video" ? Play : kind === "document" ? FileText : Image;
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      width: "100%", height: "100%", gap: 9,
      background: "linear-gradient(160deg, #F1F3F8 0%, #E6EAF1 100%)",
    }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: 46, height: 46, borderRadius: 13, background: "#FFFFFF",
        boxShadow: "0 6px 16px -10px rgba(15,23,42,.35), 0 0 0 1px rgba(15,23,42,.06)",
      }}>
        <Icon size={22} color="#6366F1" strokeWidth={1.6}/>
      </div>
      <span style={{
        fontSize: 11, fontWeight: 800, letterSpacing: 1, color: "#475569",
        padding: "3px 9px", borderRadius: 7, background: "#FFFFFF",
        boxShadow: "0 0 0 1px rgba(15,23,42,.06)",
      }}>{ext}</span>
    </div>
  );
}

// Prikaz u preview prozoru za formate koje preglednik ne može prikazati.
function PreviewFallback({ file }) {
  const ext = (getFileExt(file.name) || "FILE").toUpperCase();
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center", gap: 20,
      padding: "48px 40px", borderRadius: 20, background: "#FFFFFF",
      minWidth: 300, maxWidth: 440,
    }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: 96, height: 96, borderRadius: 24,
        background: "linear-gradient(160deg, #EEF1F8, #E2E6EF)",
      }}>
        <Image size={44} color="#6366F1" strokeWidth={1.6}/>
      </div>
      <span style={{
        fontSize: 16, fontWeight: 800, letterSpacing: 1, color: "#334155",
        padding: "6px 16px", borderRadius: 8, background: "#F1F5F9",
      }}>{ext}</span>
      <p style={{ color: "#64748B", fontSize: 14, textAlign: "center", lineHeight: 1.5, margin: 0 }}>
        Ovaj se format ({ext}) ne može prikazati u pregledniku. Preuzmite datoteku da je otvorite u odgovarajućem programu.
      </p>
    </div>
  );
}




const GLOBAL_CSS = `
  /* ACCESS_TABLE_STICKY_CUSTOMERS_V1 */
  /* ACCESS_TABLE_STICKY_CUSTOMERS_V2_EXACT */
  /* ACCESS_TABLE_STICKY_CUSTOMERS_V3_ROWS_EXACT */
  /* ADMIN_SIDEBAR_STORAGE_WIDGET_V3_FIXED */
  /* ADMIN_SIDEBAR_STORAGE_WIDGET_V4_COMPACT */
  /* ADMIN_SIDEBAR_CENTERED_SPACING_V5 */
  /* ADMIN_SIDEBAR_STORAGE_MINI_BOTTOM_V6 */
  /* ADMIN_SIDEBAR_STORAGE_TINY_BAR_V7 */
  /* ADMIN_SIDEBAR_STORAGE_FULL_WIDTH_THIN_V8 */
  /* ADMIN_CUSTOMER_CATEGORY_LAYOUT_PHASE1_V9 */
  /* ADMIN_CUSTOMER_CATEGORY_LAYOUT_PHASE1_V10_BUILD_FIX */
  /* ADMIN_CUSTOMER_CATEGORY_LAYOUT_PHASE1_V11_BUILD_FIX */
  /* ADMIN_CUSTOMER_CATEGORY_LAYOUT_PHASE1_V12_SCROLLBAR */
  /* FOLDER_PERMISSIONS_PHASE2_V14 */
  /* ADMIN_CATEGORY_DROP_UPLOAD_V15 */
  /* ADMIN_CATEGORY_DROP_UPLOAD_V16_BUILD_FIX */
  /* ADMIN_OPEN_FOLDER_DROP_AND_INHERIT_PERMS_V17 */
  /* ADMIN_OPEN_FOLDER_DROP_V18_REMOVE_UNUSED_DROPZONE */
  /* ADMIN_OPEN_FOLDER_DROP_V19_REMOVE_UNUSED_USEREF */
  /* ADMIN_OPEN_FOLDER_HEADER_BAR_V20 */
  /* ADMIN_SIDEBAR_CATEGORY_UNIQUE_ORDER_V21 */
  /* ADMIN_RENAME_FOLDERS_FILES_V22 */
  /* ADMIN_RENAME_FOLDERS_FILES_V23_REMOVE_UNUSED_UPDATEDFILE */
  /* ADMIN_DROP_ON_FOLDER_CARDS_V24 */

  /* ACCESS TABLE: keep customer names visible while horizontal scrolling */
  .access-table-wrap,
  .permissions-table-wrap,
  .access-matrix-wrap {
    position: relative;
  }

  .access-table th:first-child,
  .access-table td:first-child,
  .permissions-table th:first-child,
  .permissions-table td:first-child,
  .access-matrix th:first-child,
  .access-matrix td:first-child,
  table.access-table th:first-child,
  table.access-table td:first-child,
  table.permissions-table th:first-child,
  table.permissions-table td:first-child,
  table.access-matrix th:first-child,
  table.access-matrix td:first-child {
    position: sticky !important;
    left: 0 !important;
    z-index: 8 !important;
    background: #ffffff !important;
    box-shadow: 8px 0 14px -14px rgba(15, 23, 42, 0.55) !important;
  }

  .access-table thead th:first-child,
  .permissions-table thead th:first-child,
  .access-matrix thead th:first-child,
  table.access-table thead th:first-child,
  table.permissions-table thead th:first-child,
  table.access-matrix thead th:first-child {
    z-index: 12 !important;
    background: #f8fafc !important;
  }

  *, *::before, *::after { box-sizing: border-box; }
  html, body, #root { margin: 0; padding: 0; }
  body {
    color: ${C.text};
    background:
      radial-gradient(circle at top left, rgba(76, 89, 255, 0.08), transparent 30%),
      radial-gradient(circle at top right, rgba(0, 0, 0, 0.04), transparent 32%),
      linear-gradient(180deg, #F7F8FC 0%, #FBFBFD 32%, #FFFFFF 100%);
    font-family: ${F};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: "cv11", "ss01", "ss03";
  }
  button, a { font-family: inherit; }

  @keyframes fadeUp { from { opacity:0; transform:translateY(10px) } to { opacity:1; transform:translateY(0) } }
  @keyframes spin { to { transform:rotate(360deg) } }
  .anim-card { animation: fadeUp .5s cubic-bezier(.25,.8,.25,1) both; }
  .anim-card:nth-child(1){animation-delay:.02s} .anim-card:nth-child(2){animation-delay:.06s}
  .anim-card:nth-child(3){animation-delay:.10s} .anim-card:nth-child(4){animation-delay:.14s}
  .anim-card:nth-child(5){animation-delay:.18s} .anim-card:nth-child(6){animation-delay:.22s}

  .grid-folders-cust { display:grid; grid-template-columns:repeat(auto-fill,minmax(320px,1fr)); gap:24px; }
  @media(max-width:700px){ .grid-folders-cust { grid-template-columns:1fr; gap:16px; } }
  .grid-imgs { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:18px; }
  @media(max-width:640px){ .grid-imgs { grid-template-columns:repeat(2,1fr); gap:12px; } }
  .grid-list { display:grid; grid-template-columns:repeat(auto-fill,minmax(320px,1fr)); gap:14px; }
  @media(max-width:700px){ .grid-list { grid-template-columns:1fr; } }
  .grid-folders-admin { display:grid; grid-template-columns:repeat(auto-fill,minmax(260px,1fr)); gap:16px; }
  @media(max-width:560px){ .grid-folders-admin { grid-template-columns:1fr; } }
  .grid-admin-imgs { display:grid; grid-template-columns:repeat(auto-fill,minmax(170px,1fr)); gap:10px; }
  @media(max-width:560px){ .grid-admin-imgs { grid-template-columns:repeat(2,1fr); gap:8px; } }
  .grid-admin-list { display:grid; grid-template-columns:1fr; gap:8px; }

  .admin-root { display:flex; height:100vh; overflow:hidden; background:${C.bg}; }
  .admin-side {
    position: relative;
    width:260px; background:${C.nav}; display:flex; flex-direction:column;
    flex-shrink:0; transition:transform .3s cubic-bezier(.4,0,.2,1);
    height:100vh; overflow:hidden;
  }
  .admin-main { flex:1; min-width:0; background:${C.bg}; overflow-y:auto; overflow-x:hidden; height:100vh; }

  .admin-side-nav {
    scrollbar-width: thin;
    scrollbar-color: #8B5CF6 rgba(255,255,255,.08);
  }
  .admin-side-nav::-webkit-scrollbar {
    width: 10px;
  }
  .admin-side-nav::-webkit-scrollbar-track {
    background: rgba(255,255,255,.06);
    border-radius: 999px;
  }
  .admin-side-nav::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #C084FC 0%, #8B5CF6 55%, #6D28D9 100%);
    border-radius: 999px;
    border: 2px solid rgba(0,0,0,0);
    background-clip: padding-box;
    box-shadow: 0 0 10px rgba(139,92,246,.28);
  }
  .admin-side-nav::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #D8B4FE 0%, #A855F7 55%, #7C3AED 100%);
    background-clip: padding-box;
  }
  .admin-sidebar-accent {
    position: absolute;
    left: 12px;
    top: 0;
    bottom: 0;
    width: 3px;
    border-radius: 999px;
    background: linear-gradient(180deg,
      rgba(180, 118, 255, 0) 0%,
      rgba(180, 118, 255, .18) 12%,
      rgba(170, 92, 255, .92) 36%,
      rgba(120, 70, 255, .62) 68%,
      rgba(120, 70, 255, .18) 88%,
      rgba(120, 70, 255, 0) 100%);
    box-shadow:
      0 0 12px rgba(170, 92, 255, .22),
      0 0 28px rgba(120, 70, 255, .10);
    opacity: .92;
    pointer-events: none;
    z-index: 0;
  }
  .admin-sidebar-accent::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    width: 26px;
    border-radius: 999px;
    background: linear-gradient(90deg,
      rgba(180, 118, 255, .22) 0%,
      rgba(180, 118, 255, .10) 34%,
      rgba(180, 118, 255, 0) 100%);
    filter: blur(12px);
    pointer-events: none;
  }
  @media(max-width:768px){
    .admin-side { position:fixed; top:0; left:0; bottom:0; z-index:200; transform:translateX(-100%); box-shadow:0 0 40px rgba(0,0,0,.25); }
    .admin-side.open { transform:translateX(0); }
    .admin-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:199; backdrop-filter:blur(4px); }
    .admin-overlay.open { display:block; }
    .mobile-top { display:flex !important; }
    .admin-main { padding-top:56px; }
  }
  @media(min-width:769px){
    .admin-side { position:sticky; top:0; transform:none !important; }
    .admin-overlay { display:none !important; }
    .mobile-top { display:none !important; }
  }

  .cust-shell { height:100vh; overflow:hidden; }
  /* old .cust-nav block removed */
  .cust-nav-inner {
    max-width:1320px; margin:0 auto; padding:0 32px;
    height:78px; display:flex; align-items:center; justify-content:space-between; gap:20px;
  }
  @media(max-width:680px){ .cust-nav-inner { padding:0 18px; height:64px; } }

  .cust-main { max-width:1320px; margin:0 auto; padding:30px 32px 90px; }
  @media(max-width:960px){ .cust-main { padding:24px 24px 72px; } }
  @media(max-width:640px){ .cust-main { padding:18px 16px 48px; } }

  .cust-hero-panel {
    position:relative; overflow:hidden;
    background:
      radial-gradient(circle at 0% 0%, rgba(124, 141, 255, 0.24), transparent 34%),
      radial-gradient(circle at 100% 0%, rgba(255,255,255,.16), transparent 25%),
      linear-gradient(135deg, #0E1016 0%, #171A24 52%, #1E2230 100%);
    color:#FFF;
    border-radius:32px;
    padding:34px;
    box-shadow: 0 24px 80px -34px rgba(10,18,40,.45);
    border:1px solid rgba(255,255,255,.06);
  }
  @media(max-width:640px){ .cust-hero-panel { border-radius:24px; padding:22px; } }

  .cust-hero-grid { display:grid; grid-template-columns:minmax(0,1.5fr) minmax(280px,.85fr); gap:24px; align-items:stretch; }
  @media(max-width:980px){ .cust-hero-grid { grid-template-columns:1fr; } }

  .cust-stats { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; }
  @media(max-width:720px){ .cust-stats { grid-template-columns:1fr; } }

  .cust-stat-card {
    background:rgba(255,255,255,.08);
    border:1px solid rgba(255,255,255,.10);
    border-radius:22px;
    padding:18px 18px 16px;
    backdrop-filter:blur(14px);
  }

  .cust-section-head {
    display:flex; align-items:flex-end; justify-content:space-between; gap:16px;
    margin:34px 0 20px;
  }
  @media(max-width:640px){ .cust-section-head { flex-direction:column; align-items:flex-start; margin:26px 0 16px; } }

  .cust-folder-card {
    position:relative; overflow:hidden; cursor:pointer;
    border-radius:28px; background:rgba(255,255,255,.82);
    border:1px solid rgba(255,255,255,.85);
    box-shadow:
      0 1px 0 rgba(255,255,255,.65) inset,
      0 10px 30px -20px rgba(16,24,40,.20),
      0 0 0 1px rgba(15,23,42,.04);
    backdrop-filter: blur(18px);
    transition:transform .34s cubic-bezier(.22,1,.36,1), box-shadow .34s cubic-bezier(.22,1,.36,1), border-color .2s;
  }
  .cust-folder-card:hover {
    transform:translateY(-6px);
    box-shadow:
      0 1px 0 rgba(255,255,255,.8) inset,
      0 28px 70px -36px rgba(16,24,40,.28),
      0 0 0 1px rgba(76,89,255,.12);
    border-color:rgba(255,255,255,.95);
  }

  .cust-folder-cover {
    position:relative;
    min-height:230px;
    padding:18px;
    display:flex; align-items:flex-end;
    background:linear-gradient(180deg, rgba(250,251,255,.92) 0%, rgba(241,244,255,.96) 100%);
  }

  .cust-info-card {
    background:#FFF;
    border-radius:24px;
    border:1px solid rgba(15,23,42,.06);
    box-shadow:0 18px 48px -38px rgba(15,23,42,.2);
  }

  .cust-folder-view-hero {
    position:relative; overflow:hidden;
    border-radius:28px;
    padding:26px 28px;
    background:linear-gradient(180deg, rgba(255,255,255,.92), rgba(248,249,253,.96));
    border:1px solid rgba(15,23,42,.06);
    box-shadow:0 18px 60px -42px rgba(15,23,42,.2);
  }
  @media(max-width:640px){ .cust-folder-view-hero { padding:20px 18px; border-radius:22px; } }

  .cust-toolbar {
    display:flex; align-items:center; justify-content:space-between; gap:16px;
    margin:24px 0 20px;
  }
  @media(max-width:640px){ .cust-toolbar { flex-direction:column; align-items:flex-start; } }

  .cust-chip {
    display:inline-flex; align-items:center; gap:8px;
    padding:10px 14px; border-radius:999px;
    background:rgba(255,255,255,.74);
    border:1px solid rgba(15,23,42,.08);
    font-size:13px; font-weight:600; color:${C.text};
    backdrop-filter:blur(10px);
  }

  .cust-file-card {
    background:rgba(255,255,255,.86);
    border:2px solid #CBD5E1;
    border-radius:20px;
    box-shadow:0 12px 30px -24px rgba(15,23,42,.24);
    transition:transform .24s ease, box-shadow .24s ease, border-color .2s ease;
  }
  .cust-file-card:hover {
    transform:translateY(-3px);
    box-shadow:0 18px 38px -24px rgba(15,23,42,.22);
    border-color:#94A3B8;
  }

  .page { padding:48px; max-width:1280px; margin:0 auto; }
  @media(max-width:900px){ .page { padding:32px 28px; } }
  @media(max-width:640px){ .page { padding:24px 20px; } }

  h1, h2, h3, h4, p { margin:0; }
  .t-hero { font-size:54px; font-weight:700; letter-spacing:-2.4px; line-height:1.02; color:${C.text}; }
  @media(max-width:900px){ .t-hero { font-size:42px; letter-spacing:-1.7px; } }
  @media(max-width:640px){ .t-hero { font-size:30px; letter-spacing:-1px; } }
  .t-title { font-size:32px; font-weight:600; letter-spacing:-1px; line-height:1.1; color:${C.text}; }
  @media(max-width:640px){ .t-title { font-size:24px; letter-spacing:-.6px; } }
  .t-section { font-size:28px; font-weight:600; letter-spacing:-.8px; line-height:1.15; color:${C.text}; }
  @media(max-width:640px){ .t-section { font-size:22px; letter-spacing:-.5px; } }
  .t-eyebrow { font-size:12px; font-weight:700; letter-spacing:1.6px; text-transform:uppercase; color:${C.textMuted}; }
  .t-meta { font-size:14px; font-weight:400; color:${C.textMuted}; line-height:1.45; }

  input, select, textarea { font-family: inherit; }
  input::placeholder { color:${C.textMuted}; opacity:1; }

  .pager {
    display:flex; align-items:center; justify-content:space-between;
    flex-wrap:wrap; gap:16px; margin-top:40px;
    padding-top:24px; border-top:1px solid ${C.borderSoft};
  }
  .pager-pages { display:flex; align-items:center; gap:4px; flex-wrap:wrap; }
  @media(max-width:480px){ .pager { justify-content:center; } .pager-info { display:none; } }

  /* Customer portal – enterprise minimal redesign */
  .cust-nav {
    position: sticky; top: 0; z-index: 100;
    background: #08090F;
    overflow: hidden;
    border-bottom: 1px solid rgba(255,255,255,.06);
  }
  .cust-nav-inner {
    max-width: none; margin: 0; padding: 0 26px 0 20px;
    height: 64px; display:flex; align-items:center; justify-content:space-between; gap:20px;
  }
  @media(max-width:680px){ .cust-nav-inner { padding: 0 14px; height: 58px; } }

  .cust-main {
    max-width: none;
    margin: 0;
    padding: 0;
    min-height: calc(100vh - 64px);
    background: #F3F5F9;
  }

  .cust-app-layout {
    display: grid;
    grid-template-columns: 270px minmax(0, 1fr);
    min-height: calc(100vh - 64px);
  }
  @media(max-width:980px){
    .cust-app-layout { grid-template-columns: 1fr; }
  }

  .cust-sidebar-dark {
    background: #0B0D12;
    color: #FFF;
    border-right: 1px solid rgba(255,255,255,.06);
    padding: 22px 14px;
  }
  @media(max-width:980px){
    .cust-sidebar-dark { display:none; }
  }

  .cust-side-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: rgba(255,255,255,.38);
    margin: 18px 12px 10px;
  }

  .cust-side-link {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 12px;
    border: 0;
    border-radius: 12px;
    background: transparent;
    color: rgba(255,255,255,.92);
    text-align: left;
    cursor: default;
  }
  .cust-side-link + .cust-side-link { margin-top: 4px; }
  .cust-side-link.active {
    background: rgba(255,255,255,.08);
    box-shadow: inset 0 0 0 1px rgba(255,255,255,.04);
  }

  .cust-content-wrap {
    min-width: 0;
    padding: 28px;
  }
  @media(max-width:980px){
    .cust-content-wrap { padding: 18px; }
  }

  .cust-topbar {
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:16px;
    margin-bottom: 22px;
  }
  @media(max-width:700px){
    .cust-topbar { flex-direction: column; align-items: stretch; }
  }

  .cust-page-title {
    font-size: 20px;
    font-weight: 650;
    letter-spacing: -.5px;
    color: #1D1D1F;
  }

  .cust-toolbar-group {
    display:flex;
    align-items:center;
    gap:10px;
    flex-wrap: wrap;
  }

  .cust-search {
    display:flex;
    align-items:center;
    gap:10px;
    min-width: 260px;
    padding: 11px 14px;
    border-radius: 12px;
    background: #FFF;
    border: 1px solid rgba(15,23,42,.08);
    box-shadow: 0 8px 24px -22px rgba(15,23,42,.18);
  }
  @media(max-width:700px){ .cust-search { min-width: 100%; } }

  .cust-panel {
    background: #FFF;
    border: 1px solid rgba(15,23,42,.08);
    border-radius: 18px;
    box-shadow: 0 10px 26px -22px rgba(15,23,42,.16);
  }

  .cust-folders-grid {
    display:grid;
    grid-template-columns: repeat(auto-fill, minmax(280px,1fr));
    gap: 18px;
  }
  @media(max-width:640px){
    .cust-folders-grid { grid-template-columns: 1fr; gap: 14px; }
  }

  .cust-folder-card {
    border-radius: 16px;
    background: #FFF;
    border: 1px solid rgba(15,23,42,.08);
    box-shadow: 0 10px 26px -22px rgba(15,23,42,.16);
    transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
    cursor: pointer;
    overflow: hidden;
  }
  .cust-folder-card:hover {
    transform: translateY(-2px);
    border-color: rgba(15,23,42,.12);
    box-shadow: 0 16px 34px -24px rgba(15,23,42,.20);
  }

  .cust-folder-preview {
    height: 148px;
    background: #EEF2F7;
    border-bottom: 1px solid rgba(15,23,42,.06);
    display:flex;
    align-items:center;
    justify-content:center;
    overflow:hidden;
  }

  .cust-folder-meta {
    padding: 16px;
  }

  .cust-folder-footer {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid #EEF1F5;
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:10px;
  }

  .cust-folder-view-hero {
    background: #FFF;
    border: 1px solid rgba(15,23,42,.08);
    border-radius: 18px;
    padding: 22px 24px;
    box-shadow: 0 10px 26px -22px rgba(15,23,42,.16);
  }

  .cust-toolbar {
    display:flex; align-items:center; justify-content:space-between; gap:16px;
    margin: 18px 0;
  }
  @media(max-width:640px){ .cust-toolbar { flex-direction:column; align-items:flex-start; } }

  .cust-chip {
    display:inline-flex; align-items:center; gap:8px;
    padding:9px 12px; border-radius:999px;
    background:#FFF; border:1px solid rgba(15,23,42,.08);
    font-size:13px; font-weight:600; color:#1D1D1F;
  }

  .cust-file-card {
    background:#FFF;
    border:2px solid #CBD5E1;
    border-radius:16px;
    box-shadow: 0 10px 26px -22px rgba(15,23,42,.16);
    transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  }
  .cust-file-card:hover {
    transform: translateY(-2px);
    border-color: #94A3B8;
    box-shadow: 0 16px 34px -24px rgba(15,23,42,.20);
  }


  /* Enterprise polish */
  .cust-side-heading {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: rgba(255,255,255,.34);
    margin: 0 0 5px;
    padding-top: 7px;
    border-top: 1px solid rgba(255,255,255,.07);
  }

  .cust-side-link {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 7px 12px;
    border-radius: 14px;
    color: rgba(255,255,255,.92);
    text-decoration: none;
    border: 1px solid transparent;
    transition: background .18s ease, border-color .18s ease, transform .18s ease, color .18s ease;
  }
  .cust-side-link:hover {
    background: rgba(255,255,255,.05);
    border-color: rgba(255,255,255,.06);
    transform: translateX(2px);
  }
  .cust-side-link.active {
    background: linear-gradient(180deg, rgba(255,255,255,.10), rgba(255,255,255,.07));
    border-color: rgba(255,255,255,.08);
    box-shadow: inset 0 1px 0 rgba(255,255,255,.04);
  }
  .cust-side-link.active .cust-side-link-text { font-weight: 600; }
  .cust-side-link-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin-top: 0;
    opacity: .92;
  }
  .cust-side-link-text {
    font-size: 13px;
    line-height: 1.25;
    font-weight: 400;
    letter-spacing: -.1px;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cust-folder-layout {
    display: grid;
    grid-template-columns: 320px minmax(0, 1fr);
    gap: 24px;
    align-items: start;
  }
  @media (max-width: 1024px) {
    .cust-folder-layout {
      grid-template-columns: 1fr;
    }
  }

  .cust-folder-sidecard {
    background: #ffffff;
    border: 1px solid rgba(15,23,42,.08);
    border-radius: 20px;
    padding: 22px;
    box-shadow: 0 10px 30px -24px rgba(15,23,42,.20);
  }

  .cust-folder-main {
    min-width: 0;
  }

  .cust-folder-grid-images {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }
  @media (max-width: 640px) {
    .cust-folder-grid-images {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
    }
  }

  .cust-section-inline {
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }


  /* Explorer layout v3 */
  .cust-shell { min-height: 100vh; background: #F3F5F9; display: flex; flex-direction: column; }
  .cust-main { max-width: none; margin: 0; padding: 0; flex: 1; display: flex; flex-direction: column; }
  .cust-explorer { display: grid; grid-template-columns: 260px minmax(0, 1fr); height: calc(100vh - 78px); flex: 1; align-items: stretch; overflow: hidden; }
  .cust-sidebar-fixed {
    background: linear-gradient(180deg, #05070C 0%, #070A12 100%);
    border-right: 1px solid rgba(255,255,255,.05);
    padding: 12px 12px 12px;
    min-height: 100%;
    height: 100%;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .cust-sidebar-fixed::-webkit-scrollbar { width: 0; height: 0; display: none; }
  .cust-workspace { min-width: 0; min-height: 0; display: flex; flex-direction: column; overflow-y: auto; }
  .cust-toolbar-main {
    display: flex; align-items: center; justify-content: space-between; gap: 16px;
    padding: 26px 28px 16px;
  }

  .cust-toolbar-left {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: 18px;
    min-width: 0;
  }

  .cust-toolbar-title-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }
  .cust-toolbar-title { font-size: 18px; font-weight: 700; letter-spacing: -.3px; color: #111827; margin: 0; }
  .cust-toolbar-sub { font-size: 14px; color: #6B7280; margin-top: 6px; }
  .cust-workpanel { padding: 0 28px 28px; }
  .cust-panel {
    background: #FFFFFF; border: 1px solid rgba(15,23,42,.08); border-radius: 18px;
    box-shadow: 0 10px 30px -24px rgba(15,23,42,.18);
  }
  .cust-breadcrumbs {
    display: flex; align-items: center; gap: 10px; padding: 18px 20px;
    border-bottom: 1px solid #EEF2F7; flex-wrap: wrap;
  }
  .cust-breadcrumb-btn {
    border: none; background: transparent; color: #0F172A; font-size: 14px;
    font-weight: 600; cursor: pointer; padding: 0;
  }
  .cust-breadcrumb-muted { color: #94A3B8; font-size: 14px; font-weight: 600; }
  .cust-grid-folders {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 18px; padding: 20px;
  }
  .cust-grid-files {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
    gap: 16px; padding: 20px;
  }
  .cust-empty-state { padding: 46px 24px; text-align: center; color: #64748B; font-size: 15px; }
  .cust-folder-card {
    border-radius: 16px; background: #FFF; border: 1px solid rgba(15,23,42,.08);
    box-shadow: 0 10px 28px -24px rgba(15,23,42,.18);
    transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  }
  .cust-folder-card:hover {
    transform: translateY(-2px); border-color: rgba(15,23,42,.12);
    box-shadow: 0 16px 34px -24px rgba(15,23,42,.20);
  }
  .cust-folder-top {
    height: 150px; border-bottom: 1px solid #EEF2F7; display: flex; align-items: center;
    justify-content: center; overflow: hidden; background: linear-gradient(180deg, #F8FAFC 0%, #F1F5F9 100%);
    border-radius: 16px 16px 0 0;
  }
  .cust-folder-info { padding: 16px 16px 14px; }
  .cust-file-tile {
    background: #FFF; border: 2px solid #CBD5E1; border-radius: 16px; overflow: hidden;
    box-shadow: 0 10px 28px -24px rgba(15,23,42,.18);
    transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  }
  .cust-file-tile:hover {
    transform: translateY(-2px); border-color: #94A3B8;
    box-shadow: 0 16px 34px -24px rgba(15,23,42,.20);
  }
  .cust-file-thumb {
    aspect-ratio: 4 / 3; background: linear-gradient(180deg, #F8FAFC 0%, #F1F5F9 100%);
    display: flex; align-items: center; justify-content: center; overflow: hidden;
  }
  .cust-file-meta { padding: 12px 14px 14px; }
  @media (max-width: 980px) {
    .cust-explorer { grid-template-columns: 1fr; }
    .cust-sidebar-fixed { border-right: none; border-bottom: 1px solid rgba(255,255,255,.05); }
  }
  @media (max-width: 640px) {
    .cust-toolbar-main { padding: 18px 16px 14px; flex-direction: column; align-items: stretch; }
    .cust-workpanel { padding: 0 16px 16px; }
    .cust-grid-folders, .cust-grid-files { grid-template-columns: 1fr; padding: 16px; }
  }


  /* ── RESPONSIVE POLISH: ADMIN + CUSTOMER ── */
  @media (max-width: 1024px) {
    .admin-main { height: 100dvh; }
    .cust-workpanel { padding: 0 20px 20px; }
    .cust-grid-folders { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .cust-grid-files { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  }

  @media (max-width: 768px) {
    .admin-root { height: 100dvh; }
    .admin-side { width: min(88vw, 320px); height: 100dvh; }
    .admin-main { height: 100dvh; padding-top: 56px; }
    .page { padding: 20px 16px; }
    .t-title { font-size: 26px; }
    .t-section { font-size: 24px; }
    .grid-folders-admin { grid-template-columns: 1fr; gap: 14px; }
    .grid-admin-imgs { grid-template-columns: repeat(2, minmax(0,1fr)); gap: 10px; }
    .admin-side button { -webkit-tap-highlight-color: transparent; }

    .cust-nav-inner { padding: 0 12px !important; height: 58px !important; }
    .cust-main { padding: 0; }
    .cust-explorer { grid-template-columns: 1fr; height: calc(100dvh - 58px); }
    .cust-sidebar-fixed {
      position: sticky;
      top: 0;
      z-index: 8;
      padding: 12px;
      max-height: 36vh;
      overflow-y: auto;
      overflow-x: hidden;
      border-right: none;
      border-bottom: 1px solid rgba(255,255,255,.05);
    }
    .cust-workspace { min-height: 0; }
    .cust-toolbar-main { padding: 16px 16px 12px; gap: 12px; flex-direction: column; align-items: stretch; }
    .cust-toolbar-left { grid-template-columns: 1fr; gap: 10px; }
    .cust-toolbar-title { font-size: 16px; }
    .cust-toolbar-sub { font-size: 13px; }
    .cust-workpanel { padding: 0 16px 16px; }
    .cust-panel { border-radius: 16px; }
    .cust-breadcrumbs { padding: 14px 16px; }
    .cust-grid-folders, .cust-grid-files { grid-template-columns: 1fr; gap: 14px; padding: 16px; }
    .cust-folder-top { height: 140px; }
    .cust-file-thumb { aspect-ratio: 16 / 10; }
    .cust-file-meta, .cust-folder-info { padding: 14px; }
    .cust-side-heading { font-size: 10px; letter-spacing: 1.2px; }
    .cust-side-link { min-height: 46px; padding: 11px 12px; border-radius: 12px; }
    .cust-side-link-text { font-size: 13px; }
  }

  @media (max-width: 560px) {
    .admin-main { padding-top: 56px; }
    .page { padding: 18px 12px; }
    .grid-admin-imgs { grid-template-columns: repeat(2, minmax(0,1fr)); gap: 8px; }
    .pager { gap: 8px; }
    .pager-pages { gap: 4px; flex-wrap: wrap; justify-content: center; }

    .cust-nav-inner button[title="Početna stranica"] {
      gap: 8px !important;
      padding: 0 10px !important;
      max-width: calc(100% - 110px);
    }
    .cust-nav-inner button[title="Početna stranica"] img {
      height: 22px !important;
    }
    .cust-nav-inner button[title="Početna stranica"] div:last-child {
      font-size: 11px !important;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .cust-sidebar-fixed {
      max-height: 34vh;
      padding: 10px;
    }
    .cust-sidebar-fixed > div { gap: 20px !important; margin-top: 0 !important; }
    .cust-toolbar-main { padding: 14px 12px 10px; }
    .cust-workpanel { padding: 0 12px 12px; }
    .cust-grid-folders, .cust-grid-files { padding: 12px; }
    .cust-folder-card, .cust-file-tile { border-radius: 14px; }
    .cust-file-meta > div:last-child {
      width: 100%;
      display: grid !important;
      grid-template-columns: 1fr 1fr;
    }
    .cust-file-meta > div:last-child button {
      width: 100%;
      justify-content: center;
    }
  }

  @media (max-width: 420px) {
    .admin-side { width: 100vw; }
    .grid-admin-imgs { grid-template-columns: 1fr; }
    .cust-grid-folders, .cust-grid-files { grid-template-columns: 1fr; }
    .cust-nav-inner { padding: 0 10px !important; }
    .cust-sidebar-fixed { max-height: 32vh; }
    .cust-file-meta > div:last-child { grid-template-columns: 1fr; }
  }

  * { scroll-behavior: smooth; }


  /* CUSTOMER_FILE_BORDERS_MATCH_FOLDERS_V4_FORCE */
  .cust-file-tile,
  .cust-file-card {
    border: 2px solid #CBD5E1 !important;
    box-shadow: 0 10px 28px -24px rgba(15,23,42,.18) !important;
  }
  .cust-file-tile:hover,
  .cust-file-card:hover {
    border-color: #94A3B8 !important;
  }

  /* FINAL MOBILE CUSTOMER NAV FIX */
  @media (max-width: 768px) {
    .cust-nav-inner {
      padding: 0 10px !important;
      height: 58px !important;
      gap: 10px !important;
    }

    .cust-mobile-menu {
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .cust-overlay {
      display: none;
      position: fixed;
      inset: 58px 0 0 0;
      background: rgba(2, 6, 23, .46);
      backdrop-filter: blur(3px);
      z-index: 120;
    }
    .cust-overlay.open { display: block; }

    .cust-sidebar-fixed {
      position: fixed !important;
      top: 58px !important;
      left: 0 !important;
      bottom: 0 !important;
      width: min(84vw, 320px) !important;
      max-height: none !important;
      padding: 14px 12px 24px !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      border-right: 1px solid rgba(255,255,255,.05) !important;
      border-bottom: none !important;
      box-shadow: 0 18px 50px rgba(0,0,0,.30) !important;
      transform: translateX(-100%) !important;
      transition: transform .28s cubic-bezier(.4,0,.2,1) !important;
      z-index: 130 !important;
    }
    .cust-sidebar-fixed.open {
      transform: translateX(0) !important;
    }

    .cust-main {
      padding: 0 !important;
      max-width: none !important;
    }

    .cust-explorer {
      grid-template-columns: 1fr !important;
      height: calc(100dvh - 58px) !important;
      overflow: hidden !important;
    }

    .cust-workspace {
      min-height: 0 !important;
      overflow-y: auto !important;
    }

    .cust-brand-image {
      display: none !important;
    }

    .cust-brand-wordmark {
      display: inline-flex !important;
      align-items: center;
      gap: 8px;
      min-width: 0;
    }

    .cust-brand-sub {
      font-size: 11px !important;
      line-height: 1.1 !important;
      white-space: nowrap !important;
    }

    .cust-nav-inner button[title="Početna stranica"] {
      gap: 8px !important;
      padding: 0 8px !important;
      max-width: calc(100% - 112px) !important;
    }

    .cust-nav-inner button[title="Početna stranica"] > .cust-brand-wordmark > div:first-child {
      font-size: 13px !important;
      letter-spacing: .34em !important;
    }

    .cust-nav-inner > div:last-child > div {
      display: none !important;
    }

    .cust-toolbar-main {
      padding: 16px 16px 12px !important;
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 12px !important;
    }

    .cust-toolbar-left {
      grid-template-columns: 1fr !important;
      gap: 10px !important;
    }

    .cust-grid-folders,
    .cust-grid-files {
      grid-template-columns: 1fr !important;
      gap: 14px !important;
      padding: 14px !important;
    }

    .cust-workpanel {
      padding: 0 14px 16px !important;
    }

    .cust-panel {
      border-radius: 16px !important;
    }

    .cust-breadcrumbs {
      flex-wrap: wrap !important;
      overflow-x: hidden !important;
      row-gap: 8px !important;
    }
  }

  @media (max-width: 420px) {
    .cust-nav-inner {
      padding: 0 8px !important;
    }

    .cust-nav-inner button[title="Početna stranica"] {
      max-width: calc(100% - 98px) !important;
    }

    .cust-nav-inner button[title="Početna stranica"] > .cust-brand-wordmark > div:first-child {
      font-size: 12px !important;
      letter-spacing: .28em !important;
    }

    .cust-brand-sub {
      font-size: 10px !important;
    }
  }

  .soft-icon-box {
    position: relative;
    overflow: hidden;
  }
  .soft-icon-box::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    border-radius: 999px;
    background: linear-gradient(180deg, #a78bfa, #7c3aed);
    box-shadow: 0 0 10px rgba(139, 92, 246, 0.35);
  }
`;

/* ── Pagination hook ── */
function usePagination(items, perPage=PER) {
  const [page, setPage] = useState(1);
  useEffect(() => { setPage(1); }, [items.length]);
  const total = items.length;
  const pages = Math.max(1, Math.ceil(total / perPage));
  const safePage = Math.min(page, pages);
  const start = (safePage - 1) * perPage;
  const current = items.slice(start, start + perPage);
  return { page: safePage, setPage, pages, current, total };
}

/* ── Pager ── */
function Pager({ page, pages, setPage, total, perPage = PER, label = "stavki" }) {
  if (pages <= 1 && total <= perPage) return null;
  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);
  const nums = [];
  if (pages <= 7) for (let i = 1; i <= pages; i++) nums.push(i);
  else {
    nums.push(1);
    if (page > 4) nums.push("el");
    for (let i = Math.max(2, page - 2); i <= Math.min(pages - 1, page + 2); i++) nums.push(i);
    if (page < pages - 3) nums.push("er");
    nums.push(pages);
  }
  const PBtn = ({ pg, active, children }) => (
    <button onClick={() => { if (typeof pg === "number") setPage(pg); }}
      style={{
        minWidth: 38, height: 38,
        border: "none",
        borderRadius: 10,
        background: active ? C.text : "transparent",
        color: active ? "#FFF" : C.text,
        fontSize: 14, fontWeight: active ? 600 : 400,
        cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "0 10px",
        transition: "all .2s",
      }}
      onMouseEnter={e => { if (!active) e.currentTarget.style.background = C.hairline; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.background = "transparent"; }}>
      {children}
    </button>
  );
  return (
    <div className="pager">
      <span className="pager-info" style={{ fontSize: 14, color: C.textMuted }}>
        {start}–{end} od {total} {label}
      </span>
      <div className="pager-pages">
        <PBtn pg={page - 1}><ChevronLeft size={16}/></PBtn>
        {nums.map((n, i) =>
          typeof n === "number"
            ? <PBtn key={n} pg={n} active={n === page}>{n}</PBtn>
            : <span key={n+i} style={{ padding: "0 6px", color: C.textMuted, fontSize: 14 }}>…</span>
        )}
        <PBtn pg={page + 1}><ChevronRight size={16}/></PBtn>
      </div>
    </div>
  );
}

/* ── Confirm dialog ── */
function ConfirmDialog({ msg, onConfirm, onCancel }) {
  return (
    <div onClick={onCancel} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.55)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9998, padding: 20, backdropFilter: "blur(8px)",
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "#FFF", borderRadius: 20, padding: 32, maxWidth: 380, width: "100%",
        boxShadow: "0 20px 64px rgba(0,0,0,.3)", animation: "fadeUp .25s cubic-bezier(.25,.8,.25,1)",
      }}>
        <div style={{
          width: 56, height: 56, background: C.dangerBg, borderRadius: 50,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 20px",
        }}>
          <Trash2 size={24} color={C.danger}/>
        </div>
        <p style={{ fontSize: 18, fontWeight: 600, color: C.text, margin: "0 0 8px", textAlign: "center", letterSpacing: -.3 }}>
          Potvrda brisanja
        </p>
        <p style={{ fontSize: 14, color: C.textMuted, margin: "0 0 24px", textAlign: "center", lineHeight: 1.5 }}>
          {msg}
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onCancel} style={{
            flex: 1, padding: 12, background: C.hairline, border: "none", borderRadius: 12,
            fontSize: 15, fontWeight: 500, cursor: "pointer", color: C.text, transition: "background .15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = C.borderSoft}
          onMouseLeave={e => e.currentTarget.style.background = C.hairline}>
            Odustani
          </button>
          <button onClick={onConfirm} style={{
            flex: 1, padding: 12, background: C.danger, border: "none", borderRadius: 12,
            fontSize: 15, fontWeight: 600, cursor: "pointer", color: "#FFF",
          }}>
            Obriši
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Toast ── */
function Toast({ msg, ok }) {
  return (
    <div style={{
      position: "fixed", top: 24, right: 24,
      background: ok ? C.text : C.danger,
      color: "#FFF", borderRadius: 14,
      padding: "12px 20px", fontSize: 14, fontWeight: 500,
      zIndex: 9999, boxShadow: "0 10px 40px rgba(0,0,0,.2)",
      animation: "fadeUp .3s cubic-bezier(.25,.8,.25,1)",
    }}>
      {msg}
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════
   MAIN APP
══════════════════════════════════════════════════════════════════ */
export default function App() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) loadProfile(session.user);
      else setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      if (session) loadProfile(session.user);
      else { setUser(null); setProfile(null); setLoading(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  // Sigurnosna provjera: ako administrator obriše korisnikov račun dok je on
  // prijavljen, ovdje ga automatski odjavljujemo. Provjera ide svakih 15 sekundi
  // i svaki put kad se korisnik vrati na karticu/prozor.
  useEffect(() => {
    if (!user) return;
    let cancelled = false;

    const verifyStillValid = async () => {
      try {
        const { data, error } = await supabase
          .from("profiles")
          .select("id")
          .eq("id", user.id);
        if (cancelled) return;
        // Samo ako je upit USPIO i vratio prazno -> račun je obrisan -> odjava.
        // (Kod mrežne greške ne diramo sesiju, da ne izbacujemo bez potrebe.)
        if (!error && Array.isArray(data) && data.length === 0) {
          await supabase.auth.signOut();
        }
      } catch (_) { /* mrežna greška - ignoriramo */ }
    };

    const interval = setInterval(verifyStillValid, 15000);
    const onFocus = () => verifyStillValid();
    const onVisible = () => { if (document.visibilityState === "visible") verifyStillValid(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    const initial = setTimeout(verifyStillValid, 2000);

    return () => {
      cancelled = true;
      clearInterval(interval);
      clearTimeout(initial);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [user]);

  const loadProfile = async (u) => {
    const { data } = await supabase.from("profiles").select("*").eq("id", u.id).single();
    setUser(u); setProfile(data); setLoading(false);
  };

  if (loading) return (
    <>
      <style>{GLOBAL_CSS}</style>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: C.bg }}>
        <div style={{ width: 32, height: 32, border: `2px solid ${C.border}`, borderTopColor: C.text, borderRadius: "50%", animation: "spin .8s linear infinite" }}/>
      </div>
    </>
  );

  return (
    <>
      <style>{GLOBAL_CSS}</style>
      {!user
        ? <LoginScreen onLogin={(u, p) => { setUser(u); setProfile(p); }}/>
        : profile?.role === "admin"
          ? <AdminPanel user={user} profile={profile} onLogout={async () => { await supabase.auth.signOut(); }}/>
          : <CustomerPortal user={user} profile={profile} onLogout={async () => { await supabase.auth.signOut(); }}/>
      }
    </>
  );
}

/* ══════════════════════════════════════════════════════════════════
   LOGIN — Apple-style, centered, serene
══════════════════════════════════════════════════════════════════ */
function companyToUsername(company) {
  const map = { "č": "c", "ć": "c", "š": "s", "ž": "z", "đ": "d" };
  return (company || "")
    .trim()
    .toLowerCase()
    .replace(/[čćšžđ]/g, ch => map[ch] || ch)
    .replace(/[^a-z0-9]/g, "");
}
function companyToEmail(company) {
  return companyToUsername(company) + "@partneri.sigma-adria.com";
}
function generatePassword(len = 14) {
  const U = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const L = "abcdefghijkmnpqrstuvwxyz";
  const D = "23456789";
  const S = "!@#$%&*?";
  const all = U + L + D + S;
  const idx = (n) => {
    if (window.crypto && window.crypto.getRandomValues) {
      const a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] % n;
    }
    return Math.floor(Math.random() * n);
  };
  const chars = [U[idx(U.length)], L[idx(L.length)], D[idx(D.length)], S[idx(S.length)]];
  for (let i = chars.length; i < len; i++) chars.push(all[idx(all.length)]);
  for (let i = chars.length - 1; i > 0; i--) { const j = idx(i + 1); [chars[i], chars[j]] = [chars[j], chars[i]]; }
  return chars.join("");
}

function scrollAdminTop() {
  try {
    const el = document.querySelector(".admin-main");
    if (el) el.scrollTo({ top: 0, behavior: "smooth" });
  } catch (e) {}
}

function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const login = async () => {
    if (!username || !pass) return;
    setErr(""); setBusy(true);
    const raw = username.trim();
    const email = raw.includes("@") ? raw.toLowerCase() : companyToEmail(raw);
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: pass });
    if (error) { setErr("Pogrešno korisničko ime ili lozinka."); setBusy(false); return; }
    const { data: prof } = await supabase.from("profiles").select("*").eq("id", data.user.id).single();
    onLogin(data.user, prof);
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 88, height: 88, background: C.nav, borderRadius: 22,
            marginBottom: 24, padding: 14,
          }}>
            <img src={LOGO} alt="Solus" style={{ width: "100%", height: "100%", objectFit: "contain" }}/>
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 600, color: C.text, letterSpacing: -.8, marginBottom: 6 }}>
            Partnerski portal
          </h1>
          <p style={{ fontSize: 16, color: C.textMuted }}>
            Prijavite se kako biste nastavili
          </p>
        </div>

        <div style={{
          background: C.surface, borderRadius: 18, padding: 32,
          boxShadow: `0 0 0 1px ${C.borderSoft}`,
        }}>
          <LoginInput label="Korisničko ime" type="text" value={username} onChange={setUsername} placeholder="Ime firme ili email" onEnter={login}/>
          <LoginInput label="Lozinka" type="password" value={pass} onChange={setPass} placeholder="Vaša lozinka" onEnter={login}/>

          {err && (
            <div style={{
              background: C.dangerBg, color: C.danger, fontSize: 13,
              padding: "10px 18px", borderRadius: 10, marginBottom: 16,
              display: "flex", alignItems: "center", gap: 8,
            }}>
              <Lock size={14}/>{err}
            </div>
          )}

          <button onClick={login} disabled={busy} style={{
            width: "100%", padding: 14,
            background: busy ? C.border : C.btnPrimary,
            color: "#FFF", border: "none", borderRadius: 12,
            fontSize: 15, fontWeight: 600,
            cursor: busy ? "not-allowed" : "pointer",
            transition: "background .2s",
          }}
          onMouseEnter={e => { if (!busy) e.currentTarget.style.background = C.btnHover; }}
          onMouseLeave={e => { if (!busy) e.currentTarget.style.background = C.btnPrimary; }}>
            {busy ? "Prijava..." : "Prijava"}
          </button>
        </div>
      </div>
    </div>
  );
}

function LoginInput({ label, type, value, onChange, placeholder, onEnter }) {
  const [focused, setFocused] = useState(false);
  const [show, setShow] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword ? (show ? "text" : "password") : type;
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: C.text, marginBottom: 8 }}>
        {label}
      </label>
      <div style={{ position: "relative" }}>
        <input
          type={inputType} value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={e => e.key === "Enter" && onEnter()}
          style={{
            width: "100%", padding: isPassword ? "12px 46px 12px 14px" : "12px 14px",
            border: `1px solid ${focused ? C.text : C.border}`,
            borderRadius: 10, fontSize: 15, outline: "none",
            boxSizing: "border-box",
            background: C.surface, color: C.text,
            transition: "border-color .15s",
          }}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShow(s => !s)}
            aria-label={show ? "Sakrij lozinku" : "Prikaži lozinku"}
            title={show ? "Sakrij lozinku" : "Prikaži lozinku"}
            style={{
              position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: 32, height: 32, padding: 0,
              background: "transparent", border: "none", cursor: "pointer",
              color: C.textMuted,
            }}
          >
            {show ? <EyeOff size={18}/> : <Eye size={18}/>}
          </button>
        )}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════
   CUSTOMER PORTAL
══════════════════════════════════════════════════════════════════ */


function CustomerPortal({ user, profile, onLogout }) {
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [prev, setPrev] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [custSideOpen, setCustSideOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const categoryMetaMap = {
    "Logos and brand marks": { group: "Brand centar", color: "#7CC4FF", icon: Shield },
    "Images and lifestyle shots": { group: "Brand centar", color: "#7CC4FF", icon: Image },
    "Lens Catalog": { group: "Product Library", color: "#B9A7FF", icon: FolderOpen },
    "Product Images & Videos": { group: "Product Library", color: "#B9A7FF", icon: Image },
    "Specifications": { group: "Product Library", color: "#B9A7FF", icon: FileText },
    "Current Promotions & Campaigns": { group: "Sales and Marketing", color: "#FFB35C", icon: Play },
    "Testimonials": { group: "Sales and Marketing", color: "#FFB35C", icon: Users },
    "Warranty & Service Policies": { group: "Partner Support", color: "#6EE7C8", icon: Lock },
  };

  const normalizedSearch = search.trim().toLowerCase();

  const load = useCallback(async () => {
    const [{ data: perms }, { data: cats }] = await Promise.all([
      supabase.from("permissions").select("folder_id,user_id"),
      supabase.from("sidebar_categories").select("*").eq("is_active", true).order("sort_order"),
    ]);

    const [{ data: allFolders }, { data: allFiles }] = await Promise.all([
      supabase.from("folders").select("*").order("created_at"),
      supabase.from("files").select("*").order("created_at"),
    ]);

    const folderList = allFolders || [];
    const folderAccessMap = new Map();

    for (const permission of (perms || [])) {
      if (!permission.folder_id || !permission.user_id) continue;

      if (!folderAccessMap.has(permission.folder_id)) {
        folderAccessMap.set(permission.folder_id, new Set());
      }

      folderAccessMap.get(permission.folder_id).add(permission.user_id);
    }

    const folderById = new Map(folderList.map(folder => [folder.id, folder]));

    const getRootFolder = (folder) => {
      let current = folder;
      const visited = new Set();

      while (current?.parent_folder_id && folderById.has(current.parent_folder_id) && !visited.has(current.id)) {
        visited.add(current.id);
        current = folderById.get(current.parent_folder_id);
      }

      return current || folder;
    };

    const canSeeFolder = (folder) => {
      const rootFolder = getRootFolder(folder);
      const allowedUsers = folderAccessMap.get(rootFolder.id);

      // Prava pristupa se gledaju samo na folderu prve razine.
      // Ako folder prve razine nema nijedan zapis u permissions tablici,
      // defaultno je vidljiv svim kupcima.
      if (!allowedUsers || allowedUsers.size === 0) return true;

      return allowedUsers.has(user.id);
    };

    const visibleFolderList = folderList.filter(canSeeFolder);
    const visibleFolderIdSet = new Set(visibleFolderList.map(f => f.id));
    const visibleFileList = (allFiles || []).filter(f => visibleFolderIdSet.has(f.folder_id));
    const normalizedFiles = visibleFileList.map(normalizeFileForDisplay);
    const catList = cats || [];

    // Osvježi stanje samo ako se stvarno promijenilo (da nema treperenja ni ponovnog učitavanja slika).
    const sig = (arr) => arr.map(x => x.id).sort().join(",");
    setFolders(prev => sig(prev) === sig(visibleFolderList) ? prev : visibleFolderList);
    setFiles(prev => sig(prev) === sig(normalizedFiles) ? prev : normalizedFiles);
    setCategories(prev => sig(prev) === sig(catList) ? prev : catList);
    setLoading(false);
  }, [user.id]);

  useEffect(() => { load(); }, [load]);

  // Automatsko osvježavanje kad admin promijeni dozvole (bez ručnog refresha):
  // periodično svakih 10 s te čim se kupac vrati na karticu/prozor.
  useEffect(() => {
    const interval = setInterval(() => { load(); }, 10000);
    const onFocus = () => load();
    const onVisible = () => { if (document.visibilityState === "visible") load(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [load]);

  // Ako folder koji kupac trenutno gleda više nije dostupan (dozvola maknuta), vrati ga natrag.
  useEffect(() => {
    if (activeFolder && !folders.some(f => f.id === activeFolder.id)) {
      setActiveFolder(null);
      setPrev(null);
    }
  }, [folders, activeFolder]);

  // Kupci sada uvijek vide sve aktivne sidebar kategorije, čak i kada nemaju dostupne foldere/fileove.
  const visibleCategories = categories;

  useEffect(() => {
    if (activeFolder) return;
    if (selectedCategoryId && visibleCategories.some(c => c.id === selectedCategoryId)) return;
    if (!selectedCategoryId && !visibleCategories.length) return;
    if (!selectedCategoryId && visibleCategories.length) {
      setSelectedCategoryId(visibleCategories[0].id);
      return;
    }
    if (selectedCategoryId && !visibleCategories.some(c => c.id === selectedCategoryId)) {
      setSelectedCategoryId(visibleCategories[0]?.id || null);
    }
  }, [activeFolder, selectedCategoryId, visibleCategories]);

  useEffect(() => {
    setSearch("");
    setSelectedFiles([]);
    setCustSideOpen(false);
  }, [activeFolder?.id, selectedCategoryId]);

  useEffect(() => {
    if (loading) return;
    const path = document.getElementById("topbarWavePath");
    const ball = document.getElementById("topbarBall");
    const glow = document.getElementById("topbarBallGlow");
    const hfl = document.getElementById("topbarHFlare");
    const vfl = document.getElementById("topbarVFlare");
    const bloom = document.getElementById("topbarFlashBloom");
    const full = document.getElementById("topbarFlash");
    if (!path || !ball || !path.getPointAtLength || !path.getTotalLength) return;
    let total;
    try { total = path.getTotalLength(); } catch (e) { return; }
    if (!total) return;
    let raf;
    const DURATION = 60000;
    const TAU = 115;
    const TRIGGERS = [0.32, 0.72];
    const startTime = performance.now();
    let prevPhase = 0;
    let lastFlash = -1e9;
    const setXY = (el, x, y) => { if (el) { el.setAttribute("cx", x); el.setAttribute("cy", y); } };
    const tick = (now) => {
      const phase = ((now - startTime) % DURATION) / DURATION;
      for (let i = 0; i < TRIGGERS.length; i++) { const tp = TRIGGERS[i]; if (prevPhase < tp && phase >= tp) lastFlash = now; }
      prevPhase = phase;
      const fl = Math.exp(-(now - lastFlash) / TAU);
      let pt;
      try { pt = path.getPointAtLength(phase * total); } catch (e) { return; }
      setXY(ball, pt.x, pt.y);
      setXY(glow, pt.x, pt.y);
      setXY(hfl, pt.x, pt.y);
      setXY(vfl, pt.x, pt.y);
      setXY(bloom, pt.x, pt.y);
      if (full) full.setAttribute("opacity", (0.5 * fl).toFixed(3));
      if (bloom) { bloom.setAttribute("r", (4 + 28 * fl).toFixed(1)); bloom.setAttribute("opacity", (0.8 * fl).toFixed(3)); }
      if (hfl) { hfl.setAttribute("opacity", (0.3 + 0.5 * fl).toFixed(3)); hfl.setAttribute("rx", (150 + 80 * fl).toFixed(1)); }
      if (vfl) { vfl.setAttribute("opacity", (0.28 + 0.5 * fl).toFixed(3)); vfl.setAttribute("ry", (11 + 12 * fl).toFixed(1)); }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => { if (raf) cancelAnimationFrame(raf); };
  }, [loading]);

  const forceDownloadFile = async (file) => {
    try {
      const url = file?.storage_provider === "server" && file?.server_path
        ? buildServerDownloadUrl(file.server_path, file.original_name || file.name || "download")
        : file?.url;

      await downloadBlobFromUrl(url, file?.original_name || file?.name || "download");
    } catch (e) {
      alert(e.message || "Preuzimanje nije uspjelo.");
    }
  };

  const downloadSelectedFiles = async (items) => {
    for (const file of (items || [])) {
      await forceDownloadFile(file);
      await new Promise(resolve => setTimeout(resolve, 220));
    }
  };

  const toggleSelectedFile = (fileId) => {
    setSelectedFiles(ids => ids.includes(fileId) ? ids.filter(id => id !== fileId) : [...ids, fileId]);
  };

  const groupedCategories = [
    { title: "Brand centar", color: "#7CC4FF", items: visibleCategories.filter(c => (categoryMetaMap[c.name]?.group || "Dodatno") === "Brand centar") },
    { title: "Product Library", color: "#B9A7FF", items: visibleCategories.filter(c => (categoryMetaMap[c.name]?.group || "Dodatno") === "Product Library") },
    { title: "Sales and Marketing", color: "#FFB35C", items: visibleCategories.filter(c => (categoryMetaMap[c.name]?.group || "Dodatno") === "Sales and Marketing") },
    { title: "Partner Support", color: "#6EE7C8", items: visibleCategories.filter(c => (categoryMetaMap[c.name]?.group || "Dodatno") === "Partner Support") },
    { title: "Dodatno", color: "#A3A3A3", items: visibleCategories.filter(c => !categoryMetaMap[c.name]) },
  ].filter(group => group.items.length > 0);

  const foldersInCategory = selectedCategoryId
    ? folders.filter(f => f.sidebar_category_id === selectedCategoryId)
    : folders;

  const rootFoldersInCategory = foldersInCategory.filter(f => !f.parent_folder_id);

  const searchableFiles = selectedCategoryId
    ? files.filter(f => foldersInCategory.some(folder => folder.id === f.folder_id))
    : files;

  const filteredGlobalFiles = searchableFiles.filter(f => f.name.toLowerCase().includes(normalizedSearch));
  const pager = usePagination(rootFoldersInCategory);
  const globalFilesPager = usePagination(filteredGlobalFiles);

  const totalFiles = files.length;
  const currentFiles = activeFolder ? files.filter(f => f.folder_id === activeFolder.id) : [];
  const currentSubfolders = activeFolder ? folders.filter(f => f.parent_folder_id === activeFolder.id) : [];
  const filteredCurrentFiles = currentFiles.filter(f => f.name.toLowerCase().includes(normalizedSearch));
  const currentPager = usePagination(filteredCurrentFiles, 20);
  const currentSubfolderPager = usePagination(currentSubfolders, 20);
  const selectedCurrentFiles = filteredCurrentFiles.filter(f => selectedFiles.includes(f.id));

  const selectedCategory = visibleCategories.find(c => c.id === selectedCategoryId) || null;
  const parentActiveFolder = activeFolder?.parent_folder_id ? folders.find(f => f.id === activeFolder.parent_folder_id) : null;

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: C.bg }}>
      <div style={{ width: 28, height: 28, border: `2px solid ${C.border}`, borderTopColor: C.text, borderRadius: "50%", animation: "spin .8s linear infinite" }}/>
    </div>
  );

  return (
    <div className="cust-shell">
      <nav className="cust-nav">
        <svg
          aria-hidden="true"
          preserveAspectRatio="none"
          viewBox="0 0 1440 64"
          style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 0, pointerEvents: "none" }}
        >
          <defs>
            <linearGradient id="topbarWaveGradient" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="1440" y2="0">
              <stop offset="0" stopColor="#8B5CF6" />
              <stop offset="0.5" stopColor="#EC4899" />
              <stop offset="1" stopColor="#8B5CF6" />
            </linearGradient>
            <radialGradient id="topbarSparkGlow">
              <stop offset="0" stopColor="#FFFFFF" stopOpacity="0.95" />
              <stop offset="0.4" stopColor="#BFD4FF" stopOpacity="0.5" />
              <stop offset="1" stopColor="#BFD4FF" stopOpacity="0" />
            </radialGradient>
            <radialGradient id="topbarFlashWhite">
              <stop offset="0" stopColor="#FFFFFF" stopOpacity="1" />
              <stop offset="0.45" stopColor="#EAF1FF" stopOpacity="0.65" />
              <stop offset="1" stopColor="#EAF1FF" stopOpacity="0" />
            </radialGradient>
            <linearGradient id="topbarFlareGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#6E9BFF" stopOpacity="0" />
              <stop offset="0.5" stopColor="#CFE0FF" stopOpacity="0.95" />
              <stop offset="1" stopColor="#6E9BFF" stopOpacity="0" />
            </linearGradient>
            <filter id="topbarFlareBlur" x="-30%" y="-600%" width="160%" height="1300%">
              <feGaussianBlur stdDeviation="1.5" />
            </filter>
          </defs>
          <rect id="topbarFlash" x="0" y="0" width="1440" height="64" fill="#EAF1FF" opacity="0" style={{ mixBlendMode: "screen" }} />
          <path
            id="topbarWavePath"
            d="M0 50 L1440 50"
            fill="none"
            stroke="url(#topbarWaveGradient)"
            strokeWidth="2.2"
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
          />
          <g style={{ mixBlendMode: "screen" }}>
            <ellipse id="topbarHFlare" cx="0" cy="50" rx="150" ry="2.4" fill="url(#topbarFlareGrad)" filter="url(#topbarFlareBlur)" />
            <ellipse id="topbarVFlare" cx="0" cy="50" rx="2" ry="11" fill="#CFE0FF" opacity="0.5" filter="url(#topbarFlareBlur)" />
          </g>
          <circle id="topbarBallGlow" cx="0" cy="50" r="6" fill="url(#topbarSparkGlow)" />
          <circle id="topbarBall" cx="0" cy="50" r="2" fill="#FFFFFF" />
          <circle id="topbarFlashBloom" cx="0" cy="50" r="4" fill="url(#topbarFlashWhite)" opacity="0" style={{ mixBlendMode: "screen" }} />
        </svg>
        <div className="cust-nav-inner" style={{ maxWidth: "none", padding: "0 18px", position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ width: 170, flexShrink: 0, display: "flex", alignItems: "center", gap: 10, position: "relative", zIndex: 1 }}>
            <button
              className="cust-mobile-menu"
              onClick={() => setCustSideOpen(o => !o)}
              style={{
                display: "none",
                background: "transparent",
                border: "1px solid rgba(255,255,255,.14)",
                color: "#FFF",
                cursor: "pointer",
                padding: "8px 9px",
                borderRadius: 12,
              }}
              aria-label="Otvori navigaciju"
            >
              <Menu size={18}/>
            </button>
          </div>

          <button
            onClick={() => { setActiveFolder(null); setPrev(null); setSelectedCategoryId(null); setSearch(""); setCustSideOpen(false); }}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              alignItems: "center",
              gap: 12,
              textAlign: "center",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "0 18px",
              maxWidth: "70vw"
            }}
            title="Početna stranica"
          >
            <div className="cust-brand-wordmark" style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{
                color: "#FFFFFF",
                fontSize: 19,
                fontWeight: 600,
                letterSpacing: "0.42em",
                whiteSpace: "nowrap",
                paddingLeft: "0.21em",
                textShadow: "0 0 1px rgba(0,0,0,0.9), 0 1px 2px rgba(0,0,0,0.5)"
              }}>SOLUS</div>
              <div style={{ width: 1, height: 20, background: "rgba(255,255,255,.22)" }} />
            </div>
            <div className="cust-brand-sub" style={{ color: "rgba(255,255,255,.78)", fontSize: 13, fontWeight: 600, letterSpacing: ".2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              Partner resources
            </div>
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 12, width: 170, flexShrink: 0, justifyContent: "flex-end", position: "relative", zIndex: 1 }}>
            <div style={{ color: "rgba(255,255,255,.88)", fontSize: 14, fontWeight: 500, whiteSpace: "nowrap", maxWidth: 86, overflow: "hidden", textOverflow: "ellipsis" }}>
              {profile?.name || user.email}
            </div>
            <button onClick={onLogout} style={{
              background: "transparent", border: "1px solid rgba(255,255,255,.14)",
              color: "#FFF", cursor: "pointer", padding: "9px 10px", borderRadius: 12, display: "flex",
            }}>
              <LogOut size={16}/>
            </button>
          </div>
        </div>
      </nav>

      <div className={`cust-overlay${custSideOpen ? " open" : ""}`} onClick={() => setCustSideOpen(false)} />

      <main className="cust-main">
        <div className="cust-explorer">
          <aside className={`cust-sidebar-fixed${custSideOpen ? " open" : ""}`}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 2, flex: 1, alignItems: "stretch", minWidth: 0 }}>
              {groupedCategories.map(group => (
                <div key={group.title} style={{ display: "grid", gap: 6, alignContent: "start", minWidth: 0, gridTemplateColumns: "minmax(0, 1fr)" }}>
                  <div className="cust-side-heading" style={{ paddingTop: group.title === groupedCategories[0].title ? 0 : undefined, borderTop: group.title === groupedCategories[0].title ? "none" : undefined, color: group.color, display: "flex", alignItems: "center", gap: 8, minWidth: 0, overflow: "hidden" }}>
                    <span style={{ width: 8, height: 8, borderRadius: 999, background: group.color, boxShadow: `0 0 0 4px ${group.color}1A`, flexShrink: 0 }} />
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>{group.title}</span>
                  </div>
                  {group.items.map(cat => {
                    const meta = categoryMetaMap[cat.name] || { icon: FolderOpen };
                    const Icon = meta.icon;
                    const active = selectedCategoryId === cat.id;
                    return (
                      <button
                        key={cat.id}
                        className={`cust-side-link${active ? " active" : ""}`}
                        onClick={() => { setSelectedCategoryId(cat.id); setActiveFolder(null); setPrev(null); setSearch(""); setCustSideOpen(false); }}
                        style={{ cursor: "pointer", minWidth: 0, overflow: "hidden" }}
                      >
                        <Icon className="cust-side-link-icon" size={17} color="currentColor"/>
                        <div className="cust-side-link-text" title={cat.name}>{cat.name}</div>
                      </button>
                    );
                  })}
                </div>
              ))}
            </div>
          </aside>

          <section className="cust-workspace">
            <div className="cust-toolbar-main">
              <div className="cust-toolbar-left" style={{ display: "flex", alignItems: "center", gap: 18, minWidth: 0, flexWrap: "nowrap" }}>
                {activeFolder && (
                  <button
                    onClick={() => { setActiveFolder(parentActiveFolder || null); setPrev(null); }}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#FFFFFF",
                      border: "1px solid rgba(15,23,42,.08)",
                      color: "#0F172A",
                      cursor: "pointer",
                      padding: "10px 14px",
                      borderRadius: 12,
                      fontSize: 14,
                      fontWeight: 700,
                      boxShadow: "0 8px 24px -20px rgba(15,23,42,.20)",
                      whiteSpace: "nowrap"
                    }}
                  >
                    <ChevronLeft size={16}/> Natrag
                  </button>
                )}
                <div className="cust-toolbar-title-block">
                  <h1 className="cust-toolbar-title">{activeFolder ? activeFolder.name : (selectedCategory?.name || "Sadržaj")}</h1>
                  <div className="cust-toolbar-sub">
                    {activeFolder ? `${currentSubfolderPager.total} podfoldera • ${countFilesDeep(files, folders, activeFolder.id)} datoteka ukupno` : (search ? `${globalFilesPager.total} pronađenih datoteka` : `${pager.total} foldera • ${totalFiles} ukupno datoteka`)}
                  </div>
                </div>
              </div>

              <div style={{
                display: "flex", alignItems: "center", background: "#FFFFFF",
                border: "1px solid rgba(15,23,42,.08)", borderRadius: 14, padding: "10px 14px", minWidth: 260
              }}>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pretraži datoteke"
                  onKeyDown={(e) => {
                    if (e.key === "Escape") setSearch("");
                  }}
                  style={{ border: "none", outline: "none", background: "transparent", width: "100%", fontSize: 14, color: "#111827" }}
                />
              </div>
            </div>

            <div className="cust-workpanel">
              <div className="cust-panel">
                <div className="access-table-wrap cust-breadcrumbs" style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "nowrap", overflowX: "auto" }}>
                  {activeFolder ? (
                    <>
                      <button
  className="cust-breadcrumb-btn"
  onClick={() => {
    setActiveFolder(parentActiveFolder || null);
    setPrev(null);
  }}
  style={{
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: "#111827",
    color: "#ffffff",
    border: "1px solid #111827",
    borderRadius: 12,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 700,
    padding: "9px 14px",
    height: 44,
    lineHeight: 1,
    whiteSpace: "nowrap",
    flexShrink: 0,
    boxShadow: "0 8px 18px rgba(17, 24, 39, 0.12)",
    transition: "background .15s ease, transform .15s ease, box-shadow .15s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "#000000";
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 10px 22px rgba(17, 24, 39, 0.16)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "#111827";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 8px 18px rgba(17, 24, 39, 0.12)";
  }}
>
  <ArrowLeft size={16} />
  {parentActiveFolder ? parentActiveFolder.name : (selectedCategory?.name || "Svi folderi")}
</button>
                      <span className="cust-breadcrumb-muted" style={{ display: "inline-flex", alignItems: "center", height: 44, lineHeight: 1 }}>/</span>
                      <span style={{ display: "inline-flex", alignItems: "center", height: 44, lineHeight: 1, fontSize: 14, fontWeight: 700, color: "#0F172A", whiteSpace: "nowrap" }}>{activeFolder.name}</span>
                    </>
                  ) : (
                    <span style={{ fontSize: 14, fontWeight: 700, color: "#0F172A" }}>
                      {search ? "Rezultati pretrage" : "Svi folderi"}
                    </span>
                  )}
                </div>

                {activeFolder && (
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 14,
                    padding: "14px 20px",
                    borderBottom: "1px solid #EEF2F7",
                    flexWrap: "wrap",
                    background: "#FBFCFE"
                  }}>
                    <div style={{ fontSize: 14, color: "#64748B", fontWeight: 600 }}>
                      {selectedCurrentFiles.length ? `${selectedCurrentFiles.length} odabrano` : "Odaberi jednu ili više datoteka za preuzimanje"}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                      <button
                        onClick={() => setSelectedFiles(
                          selectedCurrentFiles.length === filteredCurrentFiles.length
                            ? []
                            : filteredCurrentFiles.map(f => f.id)
                        )}
                        style={{
                          border: "1px solid rgba(15,23,42,.08)",
                          background: "#FFF",
                          color: "#0F172A",
                          padding: "10px 12px",
                          borderRadius: 10,
                          fontSize: 13,
                          fontWeight: 700,
                          cursor: "pointer"
                        }}
                      >
                        {selectedCurrentFiles.length === filteredCurrentFiles.length ? "Makni odabir" : "Označi sve"}
                      </button>
                      <button
                        onClick={() => downloadSelectedFiles(selectedCurrentFiles)}
                        disabled={!selectedCurrentFiles.length}
                        style={{
                          border: "none",
                          background: selectedCurrentFiles.length ? "#111827" : "#CBD5E1",
                          color: "#FFF",
                          padding: "10px 14px",
                          borderRadius: 10,
                          fontSize: 13,
                          fontWeight: 700,
                          cursor: selectedCurrentFiles.length ? "pointer" : "not-allowed",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8
                        }}
                      >
                        <Download size={14}/> Preuzmi odabrano
                      </button>
                    </div>
                  </div>
                )}

                {!activeFolder ? (
                  search ? (
                    globalFilesPager.total ? (
                      <div className="cust-grid-files">
                        {globalFilesPager.current.map((f) => (
                          <CustomerFileCard key={f.id} file={f} onClick={(file) => setPrev(file)} onDownload={forceDownloadFile} />
                        ))}
                      </div>
                    ) : (
                      <div className="cust-empty-state">Nema datoteka za zadani pojam pretrage.</div>
                    )
                  ) : (
                    pager.total ? (
                      <div className="cust-grid-folders">
                        {pager.current.map((fld) => (
                          <CustomerFolderCard
                            key={fld.id}
                            folder={fld}
                            files={files.filter(x => x.folder_id === fld.id)}
                            allFiles={files}
                            allFolders={folders}
                            onClick={() => setActiveFolder(fld)}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="cust-empty-state">Trenutno nema dostupnog sadržaja u ovoj kategoriji.</div>
                    )
                  )
                ) : (
                  <>
                    {currentSubfolderPager.total > 0 && (
                      <div className="cust-grid-folders">
                        {currentSubfolderPager.current.map((fld) => (
                          <CustomerFolderCard
                            key={fld.id}
                            folder={fld}
                            files={files.filter(x => x.folder_id === fld.id)}
                            allFiles={files}
                            allFolders={folders}
                            onClick={() => setActiveFolder(fld)}
                          />
                        ))}
                      </div>
                    )}

                    {currentPager.total > 0 ? (
                      <div className="cust-grid-files">
                        {currentPager.current.map((f) => (
                          <CustomerFileCard key={f.id} file={f} onClick={(file) => setPrev(file)} onDownload={forceDownloadFile} selected={selectedFiles.includes(f.id)} onToggleSelect={toggleSelectedFile} />
                        ))}
                      </div>
                    ) : (
                      !currentSubfolderPager.total && (
                        <div className="cust-empty-state">{search ? "Nema datoteka za zadani pojam pretrage." : "U ovom folderu nema sadržaja."}</div>
                      )
                    )}
                  </>
                )}

                {!activeFolder && !search && pager.total > PER && <div style={{ padding: "0 20px 20px" }}><Pager {...pager} label="foldera"/></div>}
                {!activeFolder && search && globalFilesPager.total > PER && <div style={{ padding: "0 20px 20px" }}><Pager {...globalFilesPager} label="datoteka"/></div>}
                {activeFolder && currentSubfolderPager.total > PER && <div style={{ padding: "0 20px 0" }}><Pager {...currentSubfolderPager} label="podfoldera"/></div>}
                {activeFolder && currentPager.total > PER && <div style={{ padding: "0 20px 20px" }}><Pager {...currentPager} label="datoteka"/></div>}
              </div>
            </div>

            {prev && <PreviewModal file={prev} onClose={() => setPrev(null)}/>}
          </section>
        </div>
      </main>
    </div>
  );
}

function CustomerFolderCard({ folder, files, allFiles, allFolders, onClick }) {
  const preview = getFolderPreview(files);
  const totalCount = countFilesDeep(allFiles || files, allFolders, folder.id);

  return (
    <div className="cust-folder-card" onClick={onClick} style={{ cursor: "pointer", border: "1px solid #111827", overflow: "hidden" }}>
      <div className="cust-folder-top">
        {preview.kind === "image" ? (
          <ProtectedImage src={preview.url} alt="" style={{ maxWidth: "78%", maxHeight: "78%", objectFit: "contain", display: "block" }} />
        ) : preview.kind === "video" ? (
          <div style={{ width: 62, height: 62, borderRadius: 18, background: "linear-gradient(180deg, #0F1320, #1A2030)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Play size={28} color="#FFF" strokeWidth={1.8}/>
          </div>
        ) : preview.kind === "document" ? (
          <div className="soft-icon-box" style={{ width: 62, height: 62, borderRadius: 18, background: "linear-gradient(180deg, #F8FAFC, #EEF2F7)", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #E2E8F0" }}>
            <FileText size={28} color="#111827" strokeWidth={1.8}/>
          </div>
        ) : (
          <div style={{ width: 62, height: 62, borderRadius: 18, background: "linear-gradient(180deg, #0F1320, #1A2030)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <FolderOpen size={28} color="#FFF" strokeWidth={1.8}/>
          </div>
        )}
      </div>

      <div className="cust-folder-info">
        <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: -.4, color: "#111827", marginBottom: 8 }}>
          {folder.name}
        </div>

        <div style={{ fontSize: 14, color: "#6B7280", marginBottom: 18 }}>
          {totalCount} datoteka
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 12, paddingTop: 12, borderTop: "1px solid #111827" }}>
          <div style={{
            width: 36, height: 36, borderRadius: 12, background: "#111827",
            display: "flex", alignItems: "center", justifyContent: "center", color: "#FFF", flexShrink: 0
          }}>
            <ChevronRight size={17}/>
          </div>
        </div>
      </div>
    </div>
  );
}

function CustomerFileCard({ file, onClick, onDownload, selected = false, onToggleSelect = null }) {
  const isPreviewable = file.type === "image" || file.type === "video";
  const typeLabel = file.type === "image"
    ? (isBrowserDisplayable(file) ? "Slika" : (getFileExt(file.name) || "Grafika").toUpperCase())
    : file.type === "video" ? "Video" : "Dokument";

  return (
    <div className="cust-file-tile" style={{ cursor: isPreviewable ? "pointer" : "default", position: "relative", border: "2px solid #CBD5E1", borderRadius: 16, overflow: "hidden" }} onClick={() => { if (isPreviewable) onClick?.(file); }}>
      {onToggleSelect && (
        <button
          onClick={(e) => { e.stopPropagation(); onToggleSelect(file.id); }}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 24,
            height: 24,
            borderRadius: 999,
            border: selected ? "none" : "1px solid rgba(15,23,42,.12)",
            background: selected ? "#111827" : "rgba(255,255,255,.96)",
            color: "#FFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 2,
            boxShadow: "0 8px 20px -16px rgba(15,23,42,.30)"
          }}
          title={selected ? "Makni odabir" : "Odaberi za preuzimanje"}
        >
          {selected ? <Check size={14} color="#FFF" strokeWidth={2.5}/> : <div style={{ width: 10, height: 10 }} />}
        </button>
      )}

      <div className="cust-file-thumb">
        {file.type === "image" && (file.url && isBrowserDisplayable(file) ? (
          <ProtectedImage src={file.url} alt={file.name} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} fallback={<FileFormatPlaceholder name={file.name}/>} />
        ) : (
          <FileFormatPlaceholder name={file.name} />
        ))}

        {file.type === "video" && (
          <div style={{ width: 62, height: 62, borderRadius: 18, background: "linear-gradient(180deg, #0F1320, #1A2030)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Play size={24} color="#FFF" fill="#FFF"/>
          </div>
        )}

        {file.type === "document" && (
          <div className="soft-icon-box" style={{ width: 62, height: 62, borderRadius: 18, background: "#F8FAFC", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #E2E8F0" }}>
            <FileText size={26} color={C.text}/>
          </div>
        )}
      </div>

      <div className="cust-file-meta">
        <div style={{ fontSize: 12, color: "#94A3B8", textTransform: "uppercase", letterSpacing: 1.1, fontWeight: 700, marginBottom: 6 }}>
          {typeLabel}
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginBottom: 10 }}>
          {file.name}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <button
            onClick={(e) => { e.stopPropagation(); onDownload?.(file); }}
            style={{
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 12px",
              borderRadius: 10,
              background: "#111827",
              color: "#FFF",
              fontSize: 13,
              fontWeight: 700,
              border: "none",
              cursor: "pointer"
            }}
          >
            <Download size={14}/> Preuzmi
          </button>

          {isPreviewable && (
            <button
              onClick={(e) => { e.stopPropagation(); onClick?.(file); }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "10px 12px",
                borderRadius: 10,
                background: "#F8FAFC",
                color: "#111827",
                fontSize: 13,
                fontWeight: 700,
                border: "1px solid #E2E8F0",
                cursor: "pointer"
              }}
            >
              <Eye size={14}/> Otvori
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function PreviewModal({ file, onClose }) {
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.92)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 999, padding: 24, backdropFilter: "blur(8px)",
    }}>
      <button onClick={onClose} style={{
        position: "absolute", top: 20, right: 20, width: 44, height: 44,
        borderRadius: 50, background: "rgba(255,255,255,.15)",
        border: "none", color: "#FFF", cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <X size={22}/>
      </button>
      <div onClick={e => e.stopPropagation()}>
        {file.type === "image" && file.url && isBrowserDisplayable(file) ? (
          <ProtectedImage src={file.url} alt={file.name} style={{ maxWidth: "90vw", maxHeight: "88vh", borderRadius: 14, objectFit: "contain", background: "#FFFFFF" }} fallback={<PreviewFallback file={file}/>} />
        ) : file.type === "video" && file.url ? (
          <video controls autoPlay style={{ maxWidth: "90vw", maxHeight: "88vh", borderRadius: 14 }}>
            <source src={file.url}/>
          </video>
        ) : (
          <PreviewFallback file={file} />
        )}
      </div>
      <p style={{
        position: "absolute", bottom: 24, left: 0, right: 0,
        textAlign: "center", color: "rgba(255,255,255,.7)", fontSize: 14,
      }}>
        {file.name}
      </p>
    </div>
  );
}


function AdminSidebarStorageWidget() {
  const [storageInfo, setStorageInfo] = useState(null);
  const [storageLoading, setStorageLoading] = useState(true);
  const [storageError, setStorageError] = useState("");

  const loadStorageInfo = useCallback(async () => {
    setStorageLoading(true);
    setStorageError("");

    try {
      const token = await getSupabaseAccessToken();

      const response = await fetch(`${FILE_API_BASE}/disk-info.php`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const text = await response.text();
      let payload = null;

      try {
        payload = JSON.parse(text);
      } catch {
        throw new Error("Storage podaci nisu čitljivi.");
      }

      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.error || "Ne mogu dohvatiti stanje diska.");
      }

      setStorageInfo(payload.storage);
    } catch (error) {
      setStorageError(error.message || "Storage nedostupan.");
    } finally {
      setStorageLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStorageInfo();
  }, [loadStorageInfo]);

  const rawPercent = Number(storageInfo?.used_percent || 0);
  const usedPercent = Math.max(0, Math.min(100, rawPercent));
  const percentLabel = rawPercent < 1 ? `${rawPercent.toFixed(2)}% used` : `${rawPercent.toFixed(1)}% used`;

  return (
    <button
      type="button"
      onClick={loadStorageInfo}
      title="Klikni za osvježavanje zauzeća diska"
      style={{
        width: "100%",
        border: "1px solid rgba(255,255,255,.10)",
        borderRadius: 8,
        padding: "3px 8px",
        background: "linear-gradient(135deg, rgba(99,102,241,.96) 0%, rgba(147,51,234,.94) 58%, rgba(217,70,239,.86) 100%)",
        color: "#FFFFFF",
        cursor: "pointer",
        textAlign: "left",
        boxShadow: "0 6px 14px -14px rgba(168,85,247,.75)",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "radial-gradient(circle at 14% 0%, rgba(255,255,255,.18), transparent 44%)",
          pointerEvents: "none",
        }}
      />

      <div style={{
        position: "relative",
        height: 3,
        background: "rgba(255,255,255,.28)",
        borderRadius: 999,
        overflow: "hidden",
        marginBottom: 3,
      }}>
        <div style={{
          width: storageLoading || storageError ? "0%" : `${usedPercent}%`,
          height: "100%",
          background: "#FFFFFF",
          borderRadius: 999,
          transition: "width .25s ease",
        }} />
      </div>

      <div style={{
        position: "relative",
        fontSize: 8,
        color: "rgba(255,255,255,.92)",
        fontWeight: 800,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}>
        {storageLoading ? "Storage..." : storageError ? "Storage error" : percentLabel}
      </div>
    </button>
  );
}

/* ══════════════════════════════════════════════════════════════════
   ADMIN PANEL
══════════════════════════════════════════════════════════════════ */
function AdminPanel({ user, profile, onLogout }) {
  const [tab, setTab] = useState("folders");
  const [sideOpen, setSideOpen] = useState(false);
  const [adminCreateSeed] = useState(0);
  const [adminCategories, setAdminCategories] = useState([]);
  const [selectedAdminCategoryId, setSelectedAdminCategoryId] = useState(null);

  const categoryMetaMap = {
    "Logos and brand marks": { group: "Brand centar", color: "#7CC4FF", icon: Shield },
    "Images and lifestyle shots": { group: "Brand centar", color: "#7CC4FF", icon: Image },
    "Lens Catalog": { group: "Product Library", color: "#B9A7FF", icon: FolderOpen },
    "Product Images & Videos": { group: "Product Library", color: "#B9A7FF", icon: Image },
    "Specifications": { group: "Product Library", color: "#B9A7FF", icon: FileText },
    "Current Promotions & Campaigns": { group: "Sales and Marketing", color: "#FFB35C", icon: Play },
    "Testimonials": { group: "Sales and Marketing", color: "#FFB35C", icon: Users },
    "Warranty & Service Policies": { group: "Partner Support", color: "#6EE7C8", icon: Lock },
  };

  const loadCategories = useCallback(async () => {
    const { data } = await supabase
      .from("sidebar_categories")
      .select("*")
      .eq("is_active", true)
      .order("sort_order");

    const items = data || [];
    setAdminCategories(items);
    setSelectedAdminCategoryId(prev => (items.some(i => i.id === prev) ? prev : (items[0]?.id || null)));
  }, []);

  useEffect(() => { loadCategories(); }, [loadCategories]);

  const adminNavItems = [
    { id: "customers", label: "Kupci", Icon: Users },
    { id: "sidebar", label: "Sidebar kategorije", Icon: Folder },
  ];

  const footerBtnStyle = (active) => ({
    width: "100%", display: "flex", alignItems: "center", gap: 10,
    padding: "10px 18px", borderRadius: 10,
    background: active ? "rgba(255,255,255,.1)" : "transparent",
    border: "none",
    color: active ? "#FFF" : "rgba(255,255,255,.6)",
    cursor: "pointer", fontSize: 14, fontWeight: active ? 500 : 400,
    textAlign: "left", transition: "all .15s", marginBottom: 4,
  });

  return (
    <div className="admin-root">
      <div className={`admin-overlay${sideOpen ? " open" : ""}`} onClick={() => setSideOpen(false)}/>

      <aside className={`admin-side${sideOpen ? " open" : ""}`}>
        <div className="admin-sidebar-accent" aria-hidden="true" />
        <div style={{ padding: "32px 24px 24px" }}>
          <img src={LOGO} alt="Solus" style={{ height: 28, objectFit: "contain", filter: "brightness(10)" }}/>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,.4)", marginTop: 10, letterSpacing: 1, textTransform: "uppercase", fontWeight: 500 }}>
            Admin panel
          </div>
        </div>

        <nav className="admin-side-nav" style={{ padding: "8px 20px", flex: 1, overflowY: "auto" }}>
          <div style={{
            fontSize: 10,
            color: "rgba(255,255,255,.38)",
            letterSpacing: 1.2,
            textTransform: "uppercase",
            fontWeight: 700,
            padding: "0 18px 10px"
          }}>
            Kategorije
          </div>

          {adminCategories.map(cat => {
            const meta = categoryMetaMap[cat.name] || { icon: FolderOpen };
            const Icon = meta.icon;
            const active = tab === "folders" && selectedAdminCategoryId === cat.id;

            return (
              <button
                key={cat.id}
                onClick={() => {
                  setSelectedAdminCategoryId(cat.id);
                  setTab("folders");
                  setSideOpen(false);
                }}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "12px 18px",
                  borderRadius: 10,
                  background: active ? "rgba(255,255,255,.1)" : "transparent",
                  border: "none",
                  color: active ? "#FFF" : "rgba(255,255,255,.68)",
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: active ? 600 : 400,
                  marginBottom: 4,
                  textAlign: "left",
                  transition: "all .15s"
                }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = "rgba(255,255,255,.05)"; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = "transparent"; }}
              >
                <Icon size={17} strokeWidth={1.75}/>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{cat.name}</span>
              </button>
            );
          })}

          {!adminCategories.length && (
            <div style={{
              padding: "12px 18px",
              color: "rgba(255,255,255,.45)",
              fontSize: 13,
              lineHeight: 1.45
            }}>
              Još nema aktivnih sidebar kategorija.
            </div>
          )}
        </nav>

        <div style={{ padding: "18px 20px 28px", borderTop: "1px solid rgba(255,255,255,.08)" }}>
          {adminNavItems.map(item => {
            const active = tab === item.id;
            const Icon = item.Icon;

            return (
              <button
                key={item.id}
                onClick={() => {
                  setTab(item.id);
                  setSideOpen(false);
                }}
                style={footerBtnStyle(active)}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = "rgba(255,255,255,.05)"; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = "transparent"; }}
              >
                <Icon size={16}/>{item.label}
              </button>
            );
          })}

          <button
            onClick={() => { setTab("admins"); setSideOpen(false); }}
            style={footerBtnStyle(tab === "admins")}
            onMouseEnter={e => { if (tab !== "admins") e.currentTarget.style.background = "rgba(255,255,255,.05)"; }}
            onMouseLeave={e => { if (tab !== "admins") e.currentTarget.style.background = "transparent"; }}
          >
            <Shield size={16}/>Admini
          </button>

          <div style={{ padding: "10px 18px 12px", fontSize: 13, color: "rgba(255,255,255,.5)", marginTop: 8 }}>
            {profile?.name || user.email}
          </div>
          <button onClick={onLogout} style={{
            width: "100%", display: "flex", alignItems: "center", gap: 10,
            padding: "10px 18px", borderRadius: 10,
            background: "transparent", border: "none",
            color: "rgba(255,255,255,.5)", cursor: "pointer",
            fontSize: 14, textAlign: "left", transition: "all .15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,.05)"; e.currentTarget.style.color = "#FFF"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "rgba(255,255,255,.5)"; }}>
            <LogOut size={16}/>Odjava
          </button>

          <div style={{ width: "100%", margin: "10px 0 0 0" }}>
            <AdminSidebarStorageWidget />
          </div>
        </div>
      </aside>

      <div className="mobile-top" style={{
        display: "none", position: "fixed", top: 0, left: 0, right: 0, height: 56,
        background: C.nav, zIndex: 150, alignItems: "center",
        justifyContent: "space-between", padding: "0 16px",
      }}>
        <button onClick={() => setSideOpen(o => !o)} style={{
          background: "none", border: "none", color: "#FFF",
          cursor: "pointer", display: "flex", padding: 8,
        }}>
          <Menu size={22}/>
        </button>
        <img src={LOGO} alt="Solus" style={{ height: 24, objectFit: "contain", filter: "brightness(10)" }}/>
        <button onClick={onLogout} style={{
          background: "none", border: "none", color: "rgba(255,255,255,.6)",
          cursor: "pointer", display: "flex", padding: 8,
        }}>
          <LogOut size={18}/>
        </button>
      </div>

      <main className="admin-main">
        {tab === "folders" && <AdminFoldersFiles selectedCategoryId={selectedAdminCategoryId}/>}
        {tab === "customers" && <AdminCustomers/>}
        {tab === "sidebar" && <AdminSidebarCategories onChanged={loadCategories}/>}
        {tab === "admins" && <AdminAdmins openCreateSeed={adminCreateSeed}/>}
      </main>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════
   ADMIN: FOLDERS + FILES
══════════════════════════════════════════════════════════════════ */

function AdminFoldersFiles({ selectedCategoryId = null }) {
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [folderPerms, setFolderPerms] = useState([]);
  const [permissionsEditor, setPermissionsEditor] = useState(null);
  const [open, setOpen] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [nf, setNf] = useState({ name: "", sidebar_category_id: "", parent_folder_id: "" });
  const [toast, setToast] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadState, setUploadState] = useState({ open: false, progress: 0, current: "", total: 0, done: 0 });
  const [adminPreview, setAdminPreview] = useState(null);
  const [categoryDrag, setCategoryDrag] = useState(false);

  const flash = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3200); };
  const askConfirm = (msg, fn) => setConfirm({ msg, fn });
  const doConfirm = () => { confirm?.fn(); setConfirm(null); };

  const load = useCallback(async () => {
    const [{ data: flds }, { data: fls }, { data: cats }, { data: perms }] = await Promise.all([
      supabase.from("folders").select("*").order("created_at"),
      supabase.from("files").select("*").order("created_at"),
      supabase.from("sidebar_categories").select("*").eq("is_active", true).order("sort_order"),
      supabase.from("permissions").select("*"),
    ]);

    setFolders(flds || []);
    setFiles((fls || []).map(normalizeFileForDisplay));
    setCategories(cats || []);
    setFolderPerms(perms || []);

    try {
      const { data: { session } } = await supabase.auth.getSession();

      if (session?.access_token) {
        const res = await fetch(
          `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/list-customers`,
          {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${session.access_token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({})
          }
        );

        const result = await res.json();
        setCustomers(result.customers || []);
      }
    } catch {
      setCustomers([]);
    }

    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    setOpen(null);
    setShowNew(false);
    setNf({ name: "", sidebar_category_id: selectedCategoryId || "", parent_folder_id: "" });
  }, [selectedCategoryId]);

  const addFolder = async () => {
    if (!nf.name.trim()) {
      flash("Upišite naziv foldera.", false);
      return;
    }

    const parentFolder = nf.parent_folder_id ? folders.find(f => f.id === nf.parent_folder_id) : null;
    const resolvedCategoryId = parentFolder?.sidebar_category_id || nf.sidebar_category_id;

    if (!resolvedCategoryId) {
      flash("Odaberite sidebar kategoriju ili nad-folder.", false);
      return;
    }

    const payload = {
      name: nf.name.trim(),
      type: "other",
      sidebar_category_id: resolvedCategoryId,
      parent_folder_id: nf.parent_folder_id || null,
    };

    const { error } = await supabase.from("folders").insert(payload);
    if (error) { flash("Greška pri kreiranju foldera", false); return; }

    flash(parentFolder ? "Podfolder kreiran" : "Folder kreiran");
    setNf({ name: "", sidebar_category_id: "", parent_folder_id: "" });
    setShowNew(false);
    load();
  };

  const delFolder = (id, name) => {
    askConfirm(`Folder "${name}" i sav sadržaj unutar njega bit će trajno obrisani.`, async () => {
      const collectFolderIds = (rootId) => {
        const all = [rootId];
        let changed = true;
        while (changed) {
          changed = false;
          for (const f of folders) {
            if (f.parent_folder_id && all.includes(f.parent_folder_id) && !all.includes(f.id)) {
              all.push(f.id);
              changed = true;
            }
          }
        }
        return all;
      };

      const folderIds = collectFolderIds(id);
      const toDelete = files.filter(f => folderIds.includes(f.folder_id));

      for (const f of toDelete) {
        if (f.storage_provider === "server" && f.server_path) {
          await deleteServerFile(f.server_path);
        } else {
          const p = f.url?.split("/storage/v1/object/public/files/")?.[1];
          if (p) await supabase.storage.from("files").remove([p]);
        }
      }

      await supabase.from("folders").delete().eq("id", id);
      flash("Folder obrisan");
      if (open?.id === id) setOpen(null);
      load();
    });
  };

  const uploadFiles = async (folder, rawFiles) => {
    const selectedFiles = Array.from(rawFiles || []).map(file => ({
      file,
      relativePath: file.relativePath || file.webkitRelativePath || file.name,
    }));
    if (!selectedFiles.length) return;

    const ok = [];
    const errs = [];
    const allFolders = [...folders];
    const folderCache = new Map();

    const findExistingFolder = (name, parentFolderId, categoryId = folder.sidebar_category_id) =>
      allFolders.find(f =>
        f.name === name &&
        (f.parent_folder_id || null) === (parentFolderId || null) &&
        (!categoryId || f.sidebar_category_id === categoryId)
      );

    const ensureGeneralFolder = async () => {
      const categoryId = folder.sidebar_category_id;
      const existing = findExistingFolder("Općenito", null, categoryId);
      if (existing) return existing.id;

      const { data: created, error: createErr } = await supabase.from("folders").insert({
        name: "Općenito",
        type: "other",
        sidebar_category_id: categoryId,
        parent_folder_id: null,
      }).select().single();

      if (createErr || !created) {
        throw new Error('Ne mogu kreirati folder "Općenito".');
      }

      allFolders.push(created);
      return created.id;
    };

    const ensureFolderPath = async (relativePath) => {
      const parts = String(relativePath || "").split("/").filter(Boolean);

      if (parts.length <= 1) {
        return folder.id || await ensureGeneralFolder();
      }

      let parentId = folder.id || null;
      const subfolders = parts.slice(0, -1);

      for (const part of subfolders) {
        const cacheKey = `${parentId}__${part}`;
        if (folderCache.has(cacheKey)) {
          parentId = folderCache.get(cacheKey);
          continue;
        }

        const existing = findExistingFolder(part, parentId, folder.sidebar_category_id);
        if (existing) {
          folderCache.set(cacheKey, existing.id);
          parentId = existing.id;
          continue;
        }

        const payload = {
          name: part,
          type: "other",
          sidebar_category_id: folder.sidebar_category_id,
          parent_folder_id: parentId,
        };

        const { data: created, error: createErr } = await supabase.from("folders").insert(payload).select().single();
        if (createErr || !created) {
          throw new Error(`Ne mogu kreirati podfolder "${part}".`);
        }

        allFolders.push(created);
        folderCache.set(cacheKey, created.id);
        parentId = created.id;
      }

      return parentId;
    };

    setUploadState({
      open: true,
      progress: 0,
      current: selectedFiles[0]?.relativePath || selectedFiles[0]?.file?.name || "",
      total: selectedFiles.length,
      done: 0
    });

    for (let i = 0; i < selectedFiles.length; i++) {
      const item = selectedFiles[i];
      const rf = item.file;
      const rel = item.relativePath || rf.name;

      setUploadState({
        open: true,
        progress: Math.round((i / selectedFiles.length) * 100),
        current: rel,
        total: selectedFiles.length,
        done: i
      });

      try {
        const targetFolderId = await ensureFolderPath(rel);
        const safeName = sanitizeUploadName(rf.name);
        const uploaded = await uploadServerFile(targetFolderId, rf);
        const downloadUrl = buildServerDownloadUrl(uploaded.server_path, uploaded.original_name || uploaded.name || safeName);

        const { error: dbErr } = await supabase.from("files").insert({
          folder_id: targetFolderId,
          name: uploaded.name || safeName,
          type: mimeToType(uploaded.mime_type || rf.type || ""),
          url: downloadUrl,
          size: uploaded.size || rf.size,
          storage_provider: "server",
          server_path: uploaded.server_path,
          original_name: uploaded.original_name || uploaded.name || safeName,
          mime_type: uploaded.mime_type || rf.type || null
        });

        if (dbErr) {
          errs.push(`"${rel}": greška baze`);
          continue;
        }

        ok.push(rel);
      } catch (e) {
        errs.push(`"${rel}": ${e.message}`);
        continue;
      }

      setUploadState({
        open: true,
        progress: Math.round(((i + 1) / selectedFiles.length) * 100),
        current: rel,
        total: selectedFiles.length,
        done: i + 1
      });
    }

    setTimeout(() => {
      setUploadState({ open: false, progress: 0, current: "", total: 0, done: 0 });
    }, 500);

    if (ok.length) {
      const createdFoldersCount = allFolders.length - folders.length;
      if (createdFoldersCount > 0) {
        flash(`Učitano ${ok.length} datoteka i kreirano ${createdFoldersCount} podfoldera`);
      } else {
        flash(`Učitano ${ok.length} ${ok.length === 1 ? "datoteka" : "datoteke"}`);
      }
    }
    if (errs.length) flash(errs[0], false);
    load();
  };

  const delFile = (file) => {
    askConfirm(`Obrisati "${file.name}"?`, async () => {
      try {
        if (file.storage_provider === "server" && file.server_path) {
          await deleteServerFile(file.server_path);
        } else {
          const p = file.url?.split("/storage/v1/object/public/files/")?.[1];
          if (p) await supabase.storage.from("files").remove([p]);
        }

        await supabase.from("files").delete().eq("id", file.id);
        flash("Datoteka obrisana");
        load();
      } catch (e) {
        flash(e.message || "Greška pri brisanju datoteke", false);
      }
    });
  };

  const normalizeRenamedFileName = (currentName, requestedName) => {
    const cleanName = String(requestedName || "").trim();
    if (!cleanName) return "";

    const current = String(currentName || "").trim();
    const dotIndex = current.lastIndexOf(".");
    const currentExt = dotIndex > 0 ? current.slice(dotIndex) : "";

    if (currentExt && !cleanName.includes(".") && !cleanName.toLowerCase().endsWith(currentExt.toLowerCase())) {
      return `${cleanName}${currentExt}`;
    }

    return cleanName;
  };

  const renameFolder = async (folder) => {
    const currentName = folder?.name || "";
    const requestedName = window.prompt("Unesite novi naziv foldera:", currentName);

    if (requestedName === null) return;

    const newName = String(requestedName || "").trim();

    if (!newName) {
      flash("Naziv foldera ne smije biti prazan.", false);
      return;
    }

    if (newName === currentName) return;

    const { error } = await supabase
      .from("folders")
      .update({ name: newName })
      .eq("id", folder.id);

    if (error) {
      flash("Greška pri promjeni naziva foldera.", false);
      return;
    }

    setFolders(prev => prev.map(item => item.id === folder.id ? { ...item, name: newName } : item));
    setOpen(prev => prev?.id === folder.id ? { ...prev, name: newName } : prev);
    flash("Naziv foldera je promijenjen.");
  };

  const renameFile = async (file) => {
    const currentName = file?.original_name || file?.name || "";
    const requestedName = window.prompt("Unesite novi naziv datoteke:", currentName);

    if (requestedName === null) return;

    const newName = normalizeRenamedFileName(currentName, requestedName);

    if (!newName) {
      flash("Naziv datoteke ne smije biti prazan.", false);
      return;
    }

    if (newName === currentName && newName === file.name) return;

    const updates = {
      name: newName,
      original_name: newName,
    };

    if (file.storage_provider === "server" && file.server_path) {
      updates.url = buildServerDownloadUrl(file.server_path, newName);
    }

    const { error } = await supabase
      .from("files")
      .update(updates)
      .eq("id", file.id);

    if (error) {
      flash("Greška pri promjeni naziva datoteke.", false);
      return;
    }

    setFiles(prev => prev.map(item => item.id === file.id ? { ...item, ...updates } : item));
    setAdminPreview(prev => prev?.id === file.id ? { ...prev, ...updates } : prev);
    flash("Naziv datoteke je promijenjen.");
  };

  const getAdminFileUrl = (file) => {
    if (file?.storage_provider === "server" && file?.server_path) {
      return buildServerDownloadUrl(file.server_path, file.original_name || file.name || "download");
    }
    return file?.url || "";
  };

  const downloadAdminFile = async (file) => {
    try {
      const url = getAdminFileUrl(file);
      await downloadBlobFromUrl(url, file.original_name || file.name || "download");
    } catch (e) {
      flash(e.message || "Preuzimanje nije uspjelo.", false);
    }
  };

  const openAdminPreview = (file) => {
    const url = getAdminFileUrl(file);
    setAdminPreview({ ...file, url });
  };

  const getFolderPermissionRows = (folderId) =>
    folderPerms.filter(p => p.folder_id === folderId);

  const getFolderAccessLabel = (folderId) => {
    const rows = getFolderPermissionRows(folderId);
    if (!rows.length) return "Svi kupci";
    return `${rows.length} kupaca`;
  };

  const saveFolderPermissions = async ({ folderId, allCustomers, selectedUserIds }) => {
    const selected = Array.from(new Set(selectedUserIds || []));

    if (!allCustomers && selected.length === 0) {
      flash("Odaberi barem jednog kupca ili uključi opciju Svi kupci.", false);
      return;
    }

    const { error: deleteError } = await supabase
      .from("permissions")
      .delete()
      .eq("folder_id", folderId);

    if (deleteError) {
      flash("Greška pri spremanju prava pristupa.", false);
      return;
    }

    if (!allCustomers) {
      const rows = selected.map(userId => ({
        folder_id: folderId,
        user_id: userId,
      }));

      const { error: insertError } = await supabase
        .from("permissions")
        .insert(rows);

      if (insertError) {
        flash("Greška pri spremanju prava pristupa.", false);
        return;
      }
    }

    const { data: refreshedPerms } = await supabase.from("permissions").select("*");
    setFolderPerms(refreshedPerms || []);
    setPermissionsEditor(null);
    flash("Prava pristupa su spremljena");
  };

  const normalizeDroppedFiles = (files) =>
    Array.from(files || []).map(file => {
      if (!file.relativePath) {
        file.relativePath = file.webkitRelativePath || file.name;
      }
      return file;
    });

  const readDropEntry = async (entry, parentPath = "") => {
    if (!entry) return [];

    if (entry.isFile) {
      return await new Promise((resolve) => {
        entry.file((file) => {
          file.relativePath = `${parentPath}${file.name}`;
          resolve([file]);
        }, () => resolve([]));
      });
    }

    if (entry.isDirectory) {
      const reader = entry.createReader();
      const entries = await new Promise((resolve) => {
        const allEntries = [];
        const readBatch = () => {
          reader.readEntries((batch) => {
            if (!batch.length) {
              resolve(allEntries);
              return;
            }
            allEntries.push(...batch);
            readBatch();
          }, () => resolve(allEntries));
        };
        readBatch();
      });

      let out = [];
      for (const child of entries) {
        const childFiles = await readDropEntry(child, `${parentPath}${entry.name}/`);
        out = out.concat(childFiles);
      }
      return out;
    }

    return [];
  };

  const getFilesFromDropEvent = async (event) => {
    const items = Array.from(event.dataTransfer?.items || []);
    const entries = items
      .map(item => item.webkitGetAsEntry ? item.webkitGetAsEntry() : null)
      .filter(Boolean);

    if (entries.length) {
      let out = [];
      for (const entry of entries) {
        const entryFiles = await readDropEntry(entry);
        out = out.concat(entryFiles);
      }

      if (out.length) return normalizeDroppedFiles(out);
    }

    return normalizeDroppedFiles(event.dataTransfer?.files || []);
  };

  const uploadToSelectedCategory = async (rawFiles) => {
    const selectedCategory = categories.find(c => c.id === selectedCategoryId);

    if (!selectedCategory) {
      flash("Prvo odaberite kategoriju u lijevom izborniku.", false);
      return;
    }

    const categoryRoot = {
      id: null,
      name: selectedCategory.name,
      sidebar_category_id: selectedCategory.id,
    };

    await uploadFiles(categoryRoot, rawFiles);
  };

  const handleCategoryDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setCategoryDrag(false);

    const droppedFiles = await getFilesFromDropEvent(event);
    if (!droppedFiles.length) return;

    await uploadToSelectedCategory(droppedFiles);
  };

  const handleFolderCardDrop = async (targetFolder, event) => {
    event.preventDefault();
    event.stopPropagation();
    setCategoryDrag(false);

    const droppedFiles = await getFilesFromDropEvent(event);
    if (!droppedFiles.length) return;

    await uploadFiles(targetFolder, droppedFiles);
  };

  const openFolder = open ? (folders.find(f => f.id === open.id) || open) : null;
  const openFiles = open ? files.filter(f => f.folder_id === open.id) : [];
  const currentSubfolders = open ? folders.filter(f => f.parent_folder_id === open.id) : [];
  const folderPager = usePagination(openFiles, 20);
  const subfolderPager = usePagination(currentSubfolders, 20);
  const topLevelFolders = folders.filter(f => !f.parent_folder_id && (!selectedCategoryId || f.sidebar_category_id === selectedCategoryId));
  const gridPager = usePagination(topLevelFolders);
  const selectedAdminCategory = selectedCategoryId ? categories.find(c => c.id === selectedCategoryId) : null;

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 300 }}>
      <div style={{ width: 24, height: 24, border: `2px solid ${C.border}`, borderTopColor: C.text, borderRadius: "50%", animation: "spin .8s linear infinite" }}/>
    </div>
  );

  if (open) {
    const folder = openFolder;
    const category = categories.find(c => c.id === folder.sidebar_category_id);
    const parentFolder = folder.parent_folder_id ? folders.find(f => f.id === folder.parent_folder_id) : null;
    const meta = getFolderContentMeta(openFiles);

    const handleOpenFolderDrop = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      setCategoryDrag(false);

      const droppedFiles = await getFilesFromDropEvent(event);
      if (!droppedFiles.length) return;

      await uploadFiles(folder, droppedFiles);
    };

    return (
      <div
        className="page"
        onDragOver={e => {
          e.preventDefault();
          setCategoryDrag(true);
        }}
        onDragLeave={e => {
          if (!e.currentTarget.contains(e.relatedTarget)) {
            setCategoryDrag(false);
          }
        }}
        onDrop={handleOpenFolderDrop}
        style={{
          minHeight: "100vh",
          outline: categoryDrag ? "2px dashed #8B5CF6" : "2px dashed transparent",
          outlineOffset: -12,
          borderRadius: 18,
          transition: "outline-color .15s ease",
        }}
      >
        {toast && <Toast {...toast}/>}
        {confirm && <ConfirmDialog msg={confirm.msg} onConfirm={doConfirm} onCancel={() => setConfirm(null)}/>}
        {permissionsEditor && (
          <FolderPermissionsModal
            folder={permissionsEditor}
            customers={customers}
            permissions={getFolderPermissionRows(permissionsEditor.id)}
            onClose={() => setPermissionsEditor(null)}
            onSave={saveFolderPermissions}
          />
        )}
        {adminPreview && <PreviewModal file={adminPreview} onClose={() => setAdminPreview(null)}/>}

        {uploadState.open && (
          <div style={{
            marginBottom: 20,
            background: "#FFFFFF",
            border: `1px solid ${C.borderSoft}`,
            borderRadius: 14,
            padding: 16,
            boxShadow: `0 10px 28px -24px rgba(15,23,42,.18)`
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 10, flexWrap: "wrap" }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.text }}>
                Upload u tijeku
              </div>
              <div style={{ fontSize: 13, color: C.textMuted }}>
                {uploadState.done} / {uploadState.total} datoteka
              </div>
            </div>

            <div style={{
              width: "100%",
              height: 10,
              background: C.hairline,
              borderRadius: 999,
              overflow: "hidden",
              marginBottom: 10
            }}>
              <div style={{
                width: `${uploadState.progress}%`,
                height: "100%",
                background: "linear-gradient(90deg, #111827 0%, #374151 100%)",
                borderRadius: 999,
                transition: "width .25s ease"
              }}/>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
              <div style={{ fontSize: 13, color: C.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "75%" }}>
                Trenutno: {uploadState.current || "Priprema..."}
              </div>
              <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>
                {uploadState.progress}%
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => setOpen(parentFolder || null)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "#111827",
            color: "#ffffff",
            border: "1px solid #111827",
            borderRadius: 12,
            cursor: "pointer",
            fontSize: 14,
            fontWeight: 700,
            marginBottom: 18,
            padding: "9px 14px",
            boxShadow: "0 8px 18px rgba(17, 24, 39, 0.12)",
            transition: "background .15s ease, transform .15s ease, box-shadow .15s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#000000";
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 10px 22px rgba(17, 24, 39, 0.16)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#111827";
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 18px rgba(17, 24, 39, 0.12)";
          }}
        >
          <ArrowLeft size={16} />
          <span>{parentFolder ? parentFolder.name : "Svi folderi"}</span>
        </button>

        <div style={{
          background: "#FFFFFF",
          border: `1px solid ${C.borderSoft}`,
          borderRadius: 18,
          overflow: "hidden",
          boxShadow: "0 18px 50px -44px rgba(15,23,42,.55)",
          marginBottom: 24,
        }}>
          <div style={{
            height: 5,
            background: "linear-gradient(90deg, #7C3AED 0%, #A855F7 45%, #C084FC 100%)",
          }} />

          <div style={{
            padding: "20px 22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 18,
            flexWrap: "wrap",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 16, minWidth: 0 }}>
              <div className="soft-icon-box" style={{
                width: 46,
                height: 46,
                background: C.hairline,
                borderRadius: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}>
                <meta.Icon size={22} color={C.text} strokeWidth={1.6}/>
              </div>

              <div style={{ minWidth: 0 }}>
                <div style={{
                  fontSize: 11,
                  color: C.textMuted,
                  fontWeight: 800,
                  letterSpacing: 1.1,
                  textTransform: "uppercase",
                  marginBottom: 5,
                }}>
                  {category?.name || "Folder"}
                </div>

                <h2 style={{
                  margin: 0,
                  fontSize: 26,
                  lineHeight: 1.15,
                  fontWeight: 850,
                  letterSpacing: "-.7px",
                  color: C.text,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}>
                  {folder.name}
                </h2>

                <div style={{ marginTop: 6, fontSize: 13, color: C.textMuted, fontWeight: 600 }}>
                  {subfolderPager.total} podfoldera · {countFilesDeep(files, folders, folder.id)} datoteka ukupno
                </div>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
              <button
                onClick={() => renameFolder(folder)}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  background: "#FFFFFF",
                  color: C.text,
                  border: `1px solid ${C.borderSoft}`,
                  borderRadius: 12,
                  padding: "10px 14px",
                  fontSize: 14,
                  fontWeight: 700,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                <Pencil size={15}/>Preimenuj
              </button>

              <button
                onClick={() => {
                  setShowNew(true);
                  setNf({ name: "", sidebar_category_id: folder.sidebar_category_id || "", parent_folder_id: folder.id });
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  background: C.btnPrimary,
                  color: "#FFF",
                  border: "none",
                  borderRadius: 12,
                  padding: "10px 16px",
                  fontSize: 14,
                  fontWeight: 700,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                <Plus size={16}/>Novi podfolder
              </button>
            </div>
          </div>
        </div>

        {categoryDrag && (
          <div style={{
            marginBottom: 18,
            padding: "16px 18px",
            borderRadius: 16,
            border: "2px dashed #8B5CF6",
            background: "rgba(139,92,246,.08)",
            color: C.text,
            fontSize: 14,
            fontWeight: 800,
          }}>
            Otpustite ovdje za upload u folder "{folder.name}"
          </div>
        )}

        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 4,
          marginBottom: 16,
          paddingBottom: 10,
          borderBottom: `1px solid ${C.borderSoft}`,
          gap: 12,
          flexWrap: "wrap",
        }}>
          <p className="t-eyebrow" style={{ margin: 0 }}>
            Sadržaj foldera
          </p>
          <span style={{ fontSize: 13, color: C.textMuted, fontWeight: 600 }}>
            Povucite datoteke ili foldere bilo gdje na desnu stranu
          </span>
        </div>

        {currentSubfolders.length > 0 && (
          <div style={{ marginBottom: 32 }}>
            <div className="grid-folders-admin">
              {subfolderPager.current.map(child => {
                const childFiles = getFolderFiles(files, child.id);
                const childMeta = getFolderContentMeta(childFiles);
                const preview = getFolderPreview(childFiles);
                const childCategory = categories.find(c => c.id === child.sidebar_category_id);
                return (
                  <AdminFolderCard
                    key={child.id}
                    folder={child}
                    meta={childMeta}
                    cnt={countFilesDeep(files, folders, child.id)}
                    preview={preview}
                    category={childCategory}
                    onClick={() => setOpen(child)}
                    onDelete={() => delFolder(child.id, child.name)}
                    onRename={() => renameFolder(child)}
                    onDropFiles={(event) => handleFolderCardDrop(child, event)}
                  />
                );
              })}
            </div>
            <Pager {...subfolderPager} label="podfoldera"/>
          </div>
        )}

        {folderPager.total > 0 && (
          <div style={{ marginTop: 8 }}>
            <p className="t-eyebrow" style={{ marginBottom: 16 }}>
              Datoteke ({folderPager.total})
            </p>
            <div className="grid-admin-imgs">
              {folderPager.current.map(f => (
                <AdminFileCard key={f.id} file={f} onDelete={() => delFile(f)} onRename={() => renameFile(f)} onPreview={() => openAdminPreview(f)} onDownload={() => downloadAdminFile(f)}/>
              ))}
            </div>
            <Pager {...folderPager} label="datoteka"/>
          </div>
        )}

        {!currentSubfolders.length && !folderPager.total && (
          <div style={{ textAlign: "center", padding: "50px 0 20px", color: C.textMuted, fontSize: 14 }}>
            Ovaj folder još nema sadržaja.
          </div>
        )}

        {showNew && (
          <div style={{ marginTop: 28 }}>
            <AdminCard title="Novi podfolder" onClose={() => { setShowNew(false); setNf({ name: "", sidebar_category_id: "", parent_folder_id: "" }); }}>
              <AdminField label="Naziv foldera" v={nf.name} set={v => setNf(x => ({ ...x, name: v }))}/>
              <div style={{ marginBottom: 18 }}>
                <label style={fieldLabel}>Sidebar kategorija</label>
                <select
                  value={nf.sidebar_category_id}
                  onChange={e => setNf(x => ({ ...x, sidebar_category_id: e.target.value }))}
                  style={selectStyle}
                  disabled
                >
                  <option value="">Odaberi kategoriju</option>
                  {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
                </select>
              </div>
              <div style={{ fontSize: 13, color: C.textMuted, marginTop: -6, marginBottom: 18 }}>
                Podfolder se automatski radi unutar trenutnog foldera i nasljeđuje njegovu kategoriju.
              </div>
              <AdminSubmit label="Kreiraj podfolder" onClick={addFolder}/>
            </AdminCard>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="page"
      onDragOver={e => {
        if (!selectedAdminCategory) return;
        e.preventDefault();
        setCategoryDrag(true);
      }}
      onDragLeave={e => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setCategoryDrag(false);
        }
      }}
      onDrop={handleCategoryDrop}
      style={{
        minHeight: "100vh",
        outline: categoryDrag ? "2px dashed #8B5CF6" : "2px dashed transparent",
        outlineOffset: -12,
        borderRadius: 18,
        transition: "outline-color .15s ease",
      }}
    >
      {toast && <Toast {...toast}/>}
      {confirm && <ConfirmDialog msg={confirm.msg} onConfirm={doConfirm} onCancel={() => setConfirm(null)}/>}
        {permissionsEditor && (
          <FolderPermissionsModal
            folder={permissionsEditor}
            customers={customers}
            permissions={getFolderPermissionRows(permissionsEditor.id)}
            onClose={() => setPermissionsEditor(null)}
            onSave={saveFolderPermissions}
          />
        )}

      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: 36, flexWrap: "wrap", gap: 16,
      }}>
        <div>
          <h2 className="t-title" style={{ marginBottom: 8 }}>{selectedAdminCategory?.name || "Odaberite kategoriju"}</h2>
          {selectedAdminCategory && (
            <div style={{ color: C.textMuted, fontSize: 14, lineHeight: 1.45 }}>
              Povucite datoteke ili cijele foldere bilo gdje na ovu desnu stranu. Same datoteke automatski idu u folder "Općenito".
            </div>
          )}
        </div>
        <AdminButton label="Novi folder" onClick={() => { setShowNew(o => !o); if (!showNew) setNf({ name: "", sidebar_category_id: selectedCategoryId || "", parent_folder_id: "" }); }}/>
      </div>

      {categoryDrag && selectedAdminCategory && (
        <div style={{
          marginBottom: 18,
          padding: "16px 18px",
          borderRadius: 16,
          border: "2px dashed #8B5CF6",
          background: "rgba(139,92,246,.08)",
          color: C.text,
          fontSize: 14,
          fontWeight: 800,
        }}>
          Otpustite ovdje za upload u kategoriju "{selectedAdminCategory.name}"
        </div>
      )}

      {showNew && (
        <AdminCard title="Novi folder" onClose={() => { setShowNew(false); setNf({ name: "", sidebar_category_id: "", parent_folder_id: "" }); }}>
          <AdminField label="Naziv foldera" v={nf.name} set={v => setNf(x => ({ ...x, name: v }))}/>
          <div style={{ marginBottom: 18 }}>
            <label style={fieldLabel}>Sidebar kategorija</label>
            <select
              value={nf.sidebar_category_id}
              onChange={e => setNf(x => ({ ...x, sidebar_category_id: e.target.value }))}
              style={selectStyle}
              disabled={!!selectedCategoryId}
            >
              <option value="">Odaberi kategoriju</option>
              {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
            </select>
          </div>
          <div style={{ fontSize: 13, color: C.textMuted, marginTop: -6, marginBottom: 18 }}>
            U isti folder možeš kasnije staviti slike, videe i dokumente zajedno.
          </div>
          <AdminSubmit label="Kreiraj folder" onClick={addFolder}/>
        </AdminCard>
      )}

      {!gridPager.total && (
        <div style={{ textAlign: "center", padding: "80px 0" }}>
          <div style={{
            width: 72, height: 72, background: C.hairline, borderRadius: 20,
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 20px",
          }}>
            <FolderOpen size={32} color={C.textMuted} strokeWidth={1.5}/>
          </div>
          <p style={{ fontSize: 17, fontWeight: 500, color: C.text, marginBottom: 6 }}>
            Nema foldera
          </p>
          <p style={{ fontSize: 14, color: C.textMuted }}>
            {selectedAdminCategory ? "Povucite foldere ili kreirajte prvi folder unutar ove kategorije." : "Kreirajte prvi folder za organizaciju sadržaja."}
          </p>
        </div>
      )}

      <div className="grid-folders-admin">
        {gridPager.current.map(folder => {
          const folderFiles = getFolderFiles(files, folder.id);
          const meta = getFolderContentMeta(folderFiles);
          const preview = getFolderPreview(folderFiles);
          const category = categories.find(c => c.id === folder.sidebar_category_id);
          const cnt = countFilesDeep(files, folders, folder.id);
          return (
            <AdminFolderCard
              key={folder.id}
              folder={folder}
              meta={meta}
              cnt={cnt}
              preview={preview}
              category={category}
              onClick={() => setOpen(folder)}
              onDelete={() => delFolder(folder.id, folder.name)}
              onRename={() => renameFolder(folder)}
              onDropFiles={(event) => handleFolderCardDrop(folder, event)}
              onPermissions={() => setPermissionsEditor(folder)}
              accessLabel={getFolderAccessLabel(folder.id)}
            />
          );
        })}
      </div>
      <Pager {...gridPager} label="foldera"/>
    </div>
  );
}

function AdminFolderCard({ folder, meta, cnt, preview, category, onClick, onDelete, onRename, onDropFiles, onPermissions, accessLabel = "Svi kupci" }) {
  const [hov, setHov] = useState(false);
  const [dragOver, setDragOver] = useState(false);

  const handleDragOver = (event) => {
    if (!onDropFiles) return;

    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer.dropEffect = "copy";
    setDragOver(true);
  };

  const handleDragLeave = (event) => {
    if (!onDropFiles) return;

    event.stopPropagation();

    if (!event.currentTarget.contains(event.relatedTarget)) {
      setDragOver(false);
    }
  };

  const handleDrop = async (event) => {
    if (!onDropFiles) return;

    setDragOver(false);
    await onDropFiles(event);
  };

  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => {
        setHov(false);
        setDragOver(false);
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{
        position: "relative",
        background: C.surface, borderRadius: 16, overflow: "hidden",
        boxShadow: dragOver
          ? "0 0 0 2px #8B5CF6, 0 18px 46px -26px rgba(139,92,246,.70)"
          : hov
            ? `0 0 0 1px ${C.border}, 0 12px 32px -8px rgba(0,0,0,.1)`
            : `0 0 0 1px ${C.borderSoft}`,
        transition: "all .25s",
        transform: dragOver ? "translateY(-3px)" : hov ? "translateY(-2px)" : "translateY(0)",
      }}
    >
      <div onClick={onClick} style={{ cursor: "pointer" }}>
        <div style={{
          height: 140, background: C.hairline,
          position: "relative", overflow: "hidden",
        }}>
          {preview.kind === "image" ? (
            <ProtectedImage
              src={preview.url}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
                transform: hov ? "scale(1.04)" : "scale(1)",
                transition: "transform .4s cubic-bezier(.25,.8,.25,1)",
              }}
              fallback={
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", flexDirection: "column", gap: 8 }}>
                  <Image size={38} color={C.textMuted} strokeWidth={1.5}/>
                  <div style={{ fontSize: 12, color: C.textMuted, fontWeight: 500 }}>
                    Učitavanje slike
                  </div>
                </div>
              }
            />
          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", flexDirection: "column", gap: 8 }}>
              {preview.kind === "video" ? <Play size={38} color={C.textMuted} fill="none" strokeWidth={1.5}/> : null}
              {preview.kind === "document" ? <FileText size={38} color={C.textMuted} strokeWidth={1.5}/> : null}
              {preview.kind === "empty" ? <FolderOpen size={38} color={C.textMuted} strokeWidth={1.5}/> : null}
              <div style={{ fontSize: 12, color: C.textMuted, fontWeight: 500 }}>
                {preview.kind === "video" ? "Video sadržaj" : preview.kind === "document" ? "Dokumenti" : "Prazan folder"}
              </div>
            </div>
          )}
          {category && (
            <div style={{
              position: "absolute", top: 12, left: 12,
              background: "rgba(255,255,255,.95)", backdropFilter: "blur(12px)",
              borderRadius: 7, padding: "3px 9px",
              fontSize: 10, fontWeight: 600, color: C.text,
              letterSpacing: .4,
            }}>
              {category.name}
            </div>
          )}

          {onPermissions && (
            <button
              type="button"
              title={`Pristup: ${accessLabel}`}
              onClick={(e) => {
                e.stopPropagation();
                onPermissions();
              }}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                width: 34,
                height: 34,
                borderRadius: 11,
                border: "1px solid rgba(255,255,255,.72)",
                background: "rgba(255,255,255,.94)",
                backdropFilter: "blur(12px)",
                color: C.text,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 8px 20px -14px rgba(15,23,42,.55)",
              }}
            >
              <Users size={16} strokeWidth={2} />
            </button>
          )}
        </div>
        <div style={{ padding: "16px 18px 4px" }}>
          <p style={{ fontSize: 15, fontWeight: 500, color: C.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {folder.name}
          </p>
          <p style={{ fontSize: 13, color: C.textMuted, marginTop: 3 }}>
            {cnt} datoteka
          </p>
        </div>
      </div>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "10px 18px 16px",
        gap: 10,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
          <button onClick={onClick} style={{
            display: "flex", alignItems: "center", gap: 6,
            background: C.hairline, border: "none", color: C.text,
            borderRadius: 8, padding: "7px 12px",
            fontSize: 13, fontWeight: 500, cursor: "pointer",
            transition: "background .15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = C.borderSoft}
          onMouseLeave={e => e.currentTarget.style.background = C.hairline}>
            <UploadCloud size={14}/>Upravljaj
          </button>

          {onRename && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRename();
              }}
              title="Preimenuj folder"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                background: "#FFFFFF",
                border: `1px solid ${C.borderSoft}`,
                color: C.text,
                borderRadius: 8,
                padding: "7px 10px",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                transition: "all .15s",
              }}
              onMouseEnter={e => e.currentTarget.style.background = C.hairline}
              onMouseLeave={e => e.currentTarget.style.background = "#FFFFFF"}
            >
              <Pencil size={13}/>Naziv
            </button>
          )}
        </div>

        <button onClick={onDelete} style={{
          background: "transparent", border: "none", cursor: "pointer",
          color: C.textMuted, display: "flex", padding: 6, borderRadius: 8,
          transition: "all .15s",
        }}
        onMouseEnter={e => { e.currentTarget.style.background = C.dangerBg; e.currentTarget.style.color = C.danger; }}
        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.textMuted; }}>
          <Trash2 size={14}/>
        </button>
      </div>

      {dragOver && (
        <div style={{
          position: "absolute",
          inset: 0,
          zIndex: 40,
          pointerEvents: "none",
          background: "rgba(139,92,246,.10)",
          backdropFilter: "blur(2px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 18,
        }}>
          <div style={{
            background: "rgba(17,24,39,.94)",
            color: "#FFFFFF",
            borderRadius: 14,
            padding: "12px 16px",
            fontSize: 14,
            fontWeight: 800,
            boxShadow: "0 18px 42px -28px rgba(15,23,42,.75)",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}>
            <UploadCloud size={17}/>
            Otpusti za upload u ovaj folder
          </div>
        </div>
      )}
    </div>
  );
}


function FolderPermissionsModal({ folder, customers, permissions, onClose, onSave }) {
  const existingUserIds = permissions.map(p => p.user_id);
  const [allCustomers, setAllCustomers] = useState(existingUserIds.length === 0);
  const [selectedUserIds, setSelectedUserIds] = useState(existingUserIds);
  const [saving, setSaving] = useState(false);

  const toggleUser = (userId) => {
    setAllCustomers(false);
    setSelectedUserIds(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const selectAll = () => {
    setAllCustomers(true);
    setSelectedUserIds([]);
  };

  const save = async () => {
    setSaving(true);
    try {
      await onSave({
        folderId: folder.id,
        allCustomers,
        selectedUserIds,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,.46)",
      backdropFilter: "blur(8px)",
      zIndex: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        width: "min(520px, 100%)",
        background: "#FFFFFF",
        borderRadius: 20,
        boxShadow: "0 30px 90px -46px rgba(15,23,42,.65)",
        border: `1px solid ${C.borderSoft}`,
        overflow: "hidden",
      }}>
        <div style={{
          padding: "20px 22px",
          borderBottom: `1px solid ${C.borderSoft}`,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
        }}>
          <div>
            <div style={{ fontSize: 12, color: C.textMuted, fontWeight: 800, textTransform: "uppercase", letterSpacing: 1.1, marginBottom: 5 }}>
              Prava pristupa folderu
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.text, letterSpacing: -.4 }}>
              {folder.name}
            </div>
            <div style={{ fontSize: 13, color: C.textMuted, marginTop: 5 }}>
              Fileovi unutar foldera nasljeđuju ova prava.
            </div>
          </div>

          <button onClick={onClose} style={{
            border: "none",
            background: C.hairline,
            width: 34,
            height: 34,
            borderRadius: 10,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: C.text,
          }}>
            <X size={18} />
          </button>
        </div>

        <div style={{ padding: 22 }}>
          <button
            type="button"
            onClick={selectAll}
            style={{
              width: "100%",
              border: allCustomers ? `2px solid ${C.text}` : `1px solid ${C.borderSoft}`,
              background: allCustomers ? C.text : "#FFFFFF",
              color: allCustomers ? "#FFFFFF" : C.text,
              borderRadius: 14,
              padding: "13px 14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              cursor: "pointer",
              marginBottom: 14,
              fontWeight: 800,
            }}
          >
            <span>Svi kupci</span>
            {allCustomers && <Check size={18} />}
          </button>

          <div style={{
            maxHeight: 300,
            overflowY: "auto",
            border: `1px solid ${C.borderSoft}`,
            borderRadius: 14,
            background: C.hairline,
          }}>
            {customers.map(customer => {
              const checked = !allCustomers && selectedUserIds.includes(customer.id);

              return (
                <button
                  key={customer.id}
                  type="button"
                  onClick={() => toggleUser(customer.id)}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "#FFFFFF",
                    borderBottom: `1px solid ${C.borderSoft}`,
                    padding: "12px 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 14,
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 14, color: C.text, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {customer.name || customer.email}
                    </div>
                    <div style={{ fontSize: 12, color: C.textMuted, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {customer.company ? `${customer.company} · ` : ""}{customer.email}
                    </div>
                  </div>

                  <div style={{
                    width: 28,
                    height: 28,
                    borderRadius: 9,
                    background: checked ? C.text : C.hairline,
                    border: checked ? `1px solid ${C.text}` : `1px solid ${C.borderSoft}`,
                    color: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}>
                    {checked && <Check size={15} strokeWidth={2.8} />}
                  </div>
                </button>
              );
            })}

            {!customers.length && (
              <div style={{ padding: 22, textAlign: "center", color: C.textMuted, fontSize: 14 }}>
                Nema kupaca za prikaz.
              </div>
            )}
          </div>

          <div style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 18,
          }}>
            <button onClick={onClose} style={{
              border: `1px solid ${C.borderSoft}`,
              background: "#FFFFFF",
              color: C.text,
              borderRadius: 12,
              padding: "10px 14px",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
            }}>
              Odustani
            </button>

            <button onClick={save} disabled={saving} style={{
              border: "none",
              background: C.text,
              color: "#FFFFFF",
              borderRadius: 12,
              padding: "10px 16px",
              fontSize: 14,
              fontWeight: 800,
              cursor: saving ? "not-allowed" : "pointer",
              opacity: saving ? .7 : 1,
            }}>
              {saving ? "Spremam..." : "Spremi prava"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



function AdminFileCard({ file, onDelete, onRename, onPreview, onDownload }) {
  const [hov, setHov] = useState(false);
  const thumbKind = file.type === "video" ? "video" : file.type === "image" ? "image" : "document";

  const actionBtn = {
    background: "rgba(255,255,255,.96)", border: "none", borderRadius: 7,
    padding: "6px 10px", color: C.text, fontSize: 11, fontWeight: 600,
    cursor: "pointer", display: "flex", alignItems: "center", gap: 5,
  };
  const dangerBtn = { ...actionBtn, background: C.danger, color: "#FFF" };

  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onPreview}
      title="Klikni za prikaz"
      style={{
        position: "relative", borderRadius: 12, overflow: "hidden",
        aspectRatio: "1/1", background: C.hairline, cursor: "pointer",
        boxShadow: hov ? `0 0 0 1px ${C.border}` : `0 0 0 1px ${C.borderSoft}`,
        transition: "box-shadow .15s, transform .15s",
        transform: hov ? "translateY(-1px)" : "translateY(0)",
      }}>
      {file.type === "image" && file.url && isBrowserDisplayable(file) ? (
        <ProtectedImage src={file.url} alt={file.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} fallback={<FileFormatPlaceholder name={file.name} kind="image"/>} />
      ) : (
        <FileFormatPlaceholder name={file.name} kind={thumbKind} />
      )}
      <div style={{
        position: "absolute", inset: 0,
        background: hov ? "rgba(0,0,0,.58)" : "transparent",
        transition: "background .2s",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "flex-end", padding: 10,
      }}>
        {hov && (
          <>
            <p style={{ color: "#FFF", fontSize: 11, fontWeight: 500, marginBottom: 8, textAlign: "center", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%", lineHeight: 1.3 }} title={file.name}>
              {truncateMiddle(file.name)}
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 7, flexWrap: "wrap", justifyContent: "center" }}>
              <button onClick={(e) => { e.stopPropagation(); onPreview?.(); }} style={actionBtn}>
                <Eye size={11}/>Otvori
              </button>
              <button onClick={(e) => { e.stopPropagation(); onDownload?.(); }} style={actionBtn}>
                <Download size={11}/>Preuzmi
              </button>
              <button onClick={(e) => { e.stopPropagation(); onRename?.(); }} style={actionBtn}>
                <Pencil size={11}/>Naziv
              </button>
              <button onClick={(e) => { e.stopPropagation(); onDelete?.(); }} style={dangerBtn}>
                <Trash2 size={11}/>Obriši
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════
   ADMIN: CUSTOMERS
══════════════════════════════════════════════════════════════════ */
function AdminCustomers() {
  const emptyForm = { id: "", email: "", password: "", name: "", company: "" };

  const [customers, setCustomers] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [toast, setToast] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [f, setF] = useState(emptyForm);
  const pager = usePagination(customers);

  const flash = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3200); };
  const askConfirm = (msg, fn) => setConfirm({ msg, fn });
  const doConfirm = () => { confirm?.fn(); setConfirm(null); };

  const load = useCallback(async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/list-customers`,
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${session.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({})
        }
      );
      const result = await res.json();
      if (result.error) { flash("Greška: " + result.error, false); return; }
      setCustomers(result.customers || []);
    } catch (e) {
      flash("Greška pri učitavanju kupaca.", false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNewCustomer = () => {
    setF(emptyForm);
    setEditing(null);
    setOpen(true);
    scrollAdminTop();
  };

  const startEdit = (c) => {
    setF({
      id: c.id,
      email: c.email || "",
      password: "",
      name: c.name || "",
      company: c.company || ""
    });
    setEditing(c.id);
    setOpen(true);
    scrollAdminTop();
  };

  const saveEdit = async () => {
    if (!f.id || !f.company) {
      flash("Ime firme je obavezno.", false);
      return;
    }
    if (!companyToUsername(f.company)) {
      flash("Ime firme mora sadržavati slova ili brojeve.", false);
      return;
    }
    const email = companyToEmail(f.company);
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/update-customer`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: f.id, email, password: f.password, name: f.company, company: f.company }),
      }
    );
    const result = await res.json();
    if (result.error) { flash("Greška: " + result.error, false); return; }
    flash("Kupac spremljen");
    setF(emptyForm);
    setEditing(null);
    setOpen(false);
    load();
  };

  const add = async () => {
    if (!f.company || !f.password) {
      flash("Ime firme i lozinka su obavezni.", false);
      return;
    }
    if (!companyToUsername(f.company)) {
      flash("Ime firme mora sadržavati slova ili brojeve.", false);
      return;
    }
    const email = companyToEmail(f.company);
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-customer`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password: f.password, name: f.company, company: f.company }),
      }
    );
    const result = await res.json();
    if (result.error) { flash("Greška: " + result.error, false); return; }
    flash("Kupac dodan");
    setF(emptyForm);
    setOpen(false);
    load();
  };

  const del = (id, name) => {
    askConfirm(`Obrisati kupca "${name}"?`, async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/delete-customer`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: id }),
        }
      );
      const result = await res.json();
      if (result.error) { flash("Greška: " + result.error, false); return; }
      flash("Kupac obrisan");
      load();
    });
  };

  return (
    <div className="page">
      {toast && <Toast {...toast}/>}
      {confirm && <ConfirmDialog msg={confirm.msg} onConfirm={doConfirm} onCancel={() => setConfirm(null)}/>}

      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: 36, flexWrap: "wrap", gap: 16,
      }}>
        <h2 className="t-title">Kupci</h2>
        <AdminButton label="Dodaj kupca" onClick={openNewCustomer}/>
      </div>

      {open && (
        <AdminCard title={editing ? "Uredi kupca" : "Novi kupac"} onClose={() => { setOpen(false); setEditing(null); setF(emptyForm); }}>
          <AdminField label="Ime firme (korisničko ime)" v={f.company} set={v => setF(x => ({ ...x, company: v }))} autoComplete="off" inputName="customer_company" placeholder="npr. Aviteh"/>
          <PasswordField
            label={editing ? "Nova lozinka (ostavi prazno ako ne mijenjaš)" : "Lozinka"}
            value={f.password}
            set={v => setF(x => ({ ...x, password: v }))}
          />
          <AdminSubmit label={editing ? "Spremi promjene" : "Spremi kupca"} onClick={editing ? saveEdit : add}/>
        </AdminCard>
      )}

      <div style={{
        background: C.surface, borderRadius: 14, overflow: "hidden",
        boxShadow: `0 0 0 1px ${C.borderSoft}`,
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: C.hairline }}>
              <th style={thStyle}>Ime</th>
              <th style={thStyle}>Tvrtka</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}></th>
            </tr>
          </thead>
          <tbody>
            {pager.current.map(c => (
              <tr key={c.id} style={{ borderTop: `1px solid ${C.borderSoft}` }}>
                <td style={tdStyle}><span style={{ fontWeight: 500 }}>{c.name}</span></td>
                <td style={{ ...tdStyle, color: C.textMuted }}>{c.company || "—"}</td>
                <td style={{ ...tdStyle, color: C.textMuted }}>{c.email || "—"}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <button onClick={() => startEdit(c)} style={{
                      background: "transparent", border: `1px solid ${C.borderSoft}`, borderRadius: 8,
                      padding: "7px 11px", cursor: "pointer", color: C.text, fontSize: 13, fontWeight: 600
                    }}>
                      Uredi
                    </button>
                    <DeleteButton onClick={() => del(c.id, c.name)}/>
                  </div>
                </td>
              </tr>
            ))}
            {!pager.total && (
              <tr>
                <td colSpan={4} style={{ ...tdStyle, textAlign: "center", padding: 48, color: C.textMuted }}>
                  Nema kupaca
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pager {...pager} label="kupaca"/>
    </div>
  );
}

function AdminSidebarCategories({ onChanged }) {
  const [categories, setCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [folderCounts, setFolderCounts] = useState({});
  const [catPerms, setCatPerms] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [toast, setToast] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [form, setForm] = useState({ name: "", sort_order: 0, is_global: true, selectedUsers: [] });

  const flash = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3200); };
  const askConfirm = (msg, fn) => setConfirm({ msg, fn });
  const doConfirm = () => { confirm?.fn(); setConfirm(null); };

  const load = useCallback(async () => {
    const [{ data: catsRaw }, { data: cust }, { data: flds }, { data: perms }] = await Promise.all([
      supabase.from("sidebar_categories").select("*").order("sort_order"),
      supabase.from("profiles").select("*").eq("role", "customer").order("name"),
      supabase.from("folders").select("id, sidebar_category_id"),
      supabase.from("sidebar_category_permissions").select("*"),
    ]);

    let cats = catsRaw || [];

    // Automatski sredi redoslijed u 1, 2, 3, ... bez rupa (čuva relativni poredak).
    const sortedForFix = [...cats].sort((a, b) => {
      const ao = Number(a.sort_order) || 0;
      const bo = Number(b.sort_order) || 0;
      if (ao !== bo) return ao - bo;
      return String(a.name || "").localeCompare(String(b.name || ""), "hr");
    });
    const needsFix = sortedForFix.some((c, i) => Number(c.sort_order) !== i + 1);
    if (needsFix) {
      for (let i = 0; i < sortedForFix.length; i++) {
        if (Number(sortedForFix[i].sort_order) !== i + 1) {
          await supabase.from("sidebar_categories").update({ sort_order: i + 1 }).eq("id", sortedForFix[i].id);
        }
      }
      const { data: refetched } = await supabase.from("sidebar_categories").select("*").order("sort_order");
      cats = refetched || sortedForFix.map((c, i) => ({ ...c, sort_order: i + 1 }));
    }

    setCategories(cats);
    setCustomers(cust || []);
    setCatPerms(perms || []);
    const counts = {};
    for (const f of (flds || [])) {
      if (!f.sidebar_category_id) continue;
      counts[f.sidebar_category_id] = (counts[f.sidebar_category_id] || 0) + 1;
    }
    setFolderCounts(counts);
    if (onChanged) onChanged();
  }, [onChanged]);

  useEffect(() => { load(); }, [load]);

  const getNextSortOrder = () => {
    const maxOrder = categories.reduce((max, cat) => {
      const value = Number(cat.sort_order) || 0;
      return value > max ? value : max;
    }, 0);

    return maxOrder + 1;
  };

  const getSortedCategories = (items = categories) =>
    [...items].sort((a, b) => {
      const ao = Number(a.sort_order) || 0;
      const bo = Number(b.sort_order) || 0;
      if (ao !== bo) return ao - bo;
      return String(a.name || "").localeCompare(String(b.name || ""), "hr");
    });

  const sortOrderDuplicates = categories.reduce((acc, cat) => {
    const order = Number(cat.sort_order) || 0;
    if (!order) return acc;
    acc[order] = (acc[order] || 0) + 1;
    return acc;
  }, {});

  const hasDuplicateSortOrders = Object.values(sortOrderDuplicates).some(count => count > 1);

  const normalizeCategoryOrders = async () => {
    const sorted = getSortedCategories();

    for (let i = 0; i < sorted.length; i++) {
      const desiredOrder = i + 1;
      if (Number(sorted[i].sort_order) === desiredOrder) continue;

      const { error } = await supabase
        .from("sidebar_categories")
        .update({ sort_order: desiredOrder })
        .eq("id", sorted[i].id);

      if (error) {
        flash("Greška pri sređivanju redoslijeda.", false);
        return;
      }
    }

    flash("Redoslijed je sređen.");
    load();
  };

  const startNew = () => {
    setEditing(null);
    setForm({ name: "", sort_order: getNextSortOrder(), is_global: true, selectedUsers: [] });
    setOpen(true);
    scrollAdminTop();
  };

  const startEdit = (cat) => {
    const selectedUsers = catPerms.filter(p => p.category_id === cat.id).map(p => p.user_id);
    setEditing(cat);
    setForm({
      name: cat.name || "",
      sort_order: cat.sort_order || 0,
      is_global: !!cat.is_global,
      selectedUsers,
    });
    setOpen(true);
    scrollAdminTop();
  };

  const saveCategory = async () => {
    if (!form.name.trim()) {
      flash("Upišite naziv kategorije.", false);
      return;
    }

    const desiredOrder = Number(form.sort_order);

    if (!Number.isInteger(desiredOrder) || desiredOrder < 1) {
      flash("Redoslijed mora biti pozitivan cijeli broj.", false);
      return;
    }

    const duplicate = categories.find(cat =>
      cat.id !== editing?.id && Number(cat.sort_order) === desiredOrder
    );

    if (duplicate) {
      flash(`Redoslijed ${desiredOrder} već koristi kategorija "${duplicate.name}". Odaberite drugi broj.`, false);
      return;
    }

    let categoryId = editing?.id || null;
    if (editing) {
      const { error } = await supabase.from("sidebar_categories").update({
        name: form.name.trim(),
        sort_order: desiredOrder,
        is_global: form.is_global,
      }).eq("id", editing.id);
      if (error) { flash("Greška pri spremanju kategorije.", false); return; }
      categoryId = editing.id;
    } else {
      const { data, error } = await supabase.from("sidebar_categories").insert({
        name: form.name.trim(),
        sort_order: desiredOrder,
        is_global: form.is_global,
        is_active: true,
      }).select().single();
      if (error || !data) { flash("Greška pri kreiranju kategorije.", false); return; }
      categoryId = data.id;
    }

    if (categoryId) {
      await supabase.from("sidebar_category_permissions").delete().eq("category_id", categoryId);
      if (!form.is_global && form.selectedUsers.length) {
        const rows = form.selectedUsers.map(userId => ({ category_id: categoryId, user_id: userId }));
        await supabase.from("sidebar_category_permissions").insert(rows);
      }
    }

    flash(editing ? "Kategorija spremljena" : "Kategorija dodana");
    setOpen(false);
    setEditing(null);
    setForm({ name: "", sort_order: 0, is_global: true, selectedUsers: [] });
    load();
  };

  const deleteCategory = (cat) => {
    const count = folderCounts[cat.id] || 0;
    if (count > 0) {
      flash("Kategorija se ne može obrisati dok ima foldera unutar sebe.", false);
      return;
    }
    askConfirm(`Obrisati kategoriju "${cat.name}"?`, async () => {
      await supabase.from("sidebar_categories").delete().eq("id", cat.id);
      flash("Kategorija obrisana");
      load();
    });
  };

  const toggleUser = (userId) => {
    setForm(x => ({
      ...x,
      selectedUsers: x.selectedUsers.includes(userId)
        ? x.selectedUsers.filter(id => id !== userId)
        : [...x.selectedUsers, userId]
    }));
  };

  const toggleAllUsers = () => {
    setForm(x => ({
      ...x,
      selectedUsers: x.selectedUsers.length === customers.length ? [] : customers.map(c => c.id)
    }));
  };

  const pager = usePagination(getSortedCategories());

  return (
    <div className="page">
      {toast && <Toast {...toast}/>}
      {confirm && <ConfirmDialog msg={confirm.msg} onConfirm={doConfirm} onCancel={() => setConfirm(null)}/>}

      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: hasDuplicateSortOrders ? 16 : 36, flexWrap: "wrap", gap: 16,
      }}>
        <h2 className="t-title">Sidebar kategorije</h2>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          {hasDuplicateSortOrders && (
            <button
              onClick={normalizeCategoryOrders}
              style={{
                background: "#fff",
                color: C.text,
                border: `1px solid ${C.borderSoft}`,
                borderRadius: 10,
                padding: "10px 14px",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Sredi redoslijed
            </button>
          )}
          <AdminButton label="Nova kategorija" onClick={startNew}/>
        </div>
      </div>

      {hasDuplicateSortOrders && (
        <div style={{
          marginBottom: 24,
          padding: "13px 16px",
          borderRadius: 14,
          background: "rgba(245,158,11,.10)",
          border: "1px solid rgba(245,158,11,.28)",
          color: C.text,
          fontSize: 14,
          fontWeight: 700,
        }}>
          Neke kategorije imaju isti broj u redoslijedu. Kliknite "Sredi redoslijed" kako bi svaka kategorija dobila jedinstven broj.
        </div>
      )}

      {open && (
        <AdminCard title={editing ? "Uredi kategoriju" : "Nova kategorija"} onClose={() => setOpen(false)}>
          <AdminField label="Naziv kategorije" v={form.name} set={v => setForm(x => ({ ...x, name: v }))}/>
          <div style={{ marginBottom: 16 }}>
            <label style={fieldLabel}>Redoslijed</label>
            <input
              type="number"
              min="1"
              step="1"
              value={form.sort_order}
              onChange={e => setForm(x => ({ ...x, sort_order: e.target.value }))}
              style={{ ...selectStyle }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={form.is_global}
                onChange={e => setForm(x => ({ ...x, is_global: e.target.checked }))}
              />
              <span style={{ fontSize: 14, color: C.text }}>Vidljivo svim kupcima</span>
            </label>
          </div>

          {!form.is_global && (
            <div style={{ marginBottom: 18 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <label style={fieldLabel}>Vidljivo samo odabranim kupcima</label>
                <button onClick={toggleAllUsers} style={{
                  background: "none", border: "none", cursor: "pointer",
                  color: C.text, fontSize: 13, fontWeight: 600
                }}>
                  {form.selectedUsers.length === customers.length ? "Makni sve" : "Označi sve"}
                </button>
              </div>
              <div style={{
                maxHeight: 220, overflow: "auto", border: `1px solid ${C.border}`,
                borderRadius: 10, padding: 10
              }}>
                {customers.map(c => (
                  <label key={c.id} style={{
                    display: "flex", alignItems: "center", gap: 10, padding: "8px 6px", cursor: "pointer"
                  }}>
                    <input
                      type="checkbox"
                      checked={form.selectedUsers.includes(c.id)}
                      onChange={() => toggleUser(c.id)}
                    />
                    <span style={{ fontSize: 14, color: C.text }}>
                      {c.name}{c.company ? ` · ${c.company}` : ""}
                    </span>
                  </label>
                ))}
                {!customers.length && (
                  <div style={{ fontSize: 13, color: C.textMuted }}>Nema kupaca.</div>
                )}
              </div>
            </div>
          )}

          <AdminSubmit label={editing ? "Spremi promjene" : "Dodaj kategoriju"} onClick={saveCategory}/>
        </AdminCard>
      )}

      <div style={{
        background: C.surface, borderRadius: 14, overflow: "hidden",
        boxShadow: `0 0 0 1px ${C.borderSoft}`,
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: C.hairline }}>
              <th style={thStyle}>Naziv</th>
              <th style={thStyle}>Redoslijed</th>
              <th style={thStyle}>Vidljivost</th>
              <th style={thStyle}>Foldera</th>
              <th style={thStyle}></th>
            </tr>
          </thead>
          <tbody>
            {pager.current.map(cat => (
              <tr key={cat.id} style={{ borderTop: `1px solid ${C.borderSoft}` }}>
                <td style={tdStyle}><span style={{ fontWeight: 500 }}>{cat.name}</span></td>
                <td style={tdStyle}>{cat.sort_order}</td>
                <td style={{ ...tdStyle, color: C.textMuted }}>
                  {cat.is_global ? "Svi kupci" : `${catPerms.filter(p => p.category_id === cat.id).length} kupaca`}
                </td>
                <td style={{ ...tdStyle, color: C.textMuted }}>{folderCounts[cat.id] || 0}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <button onClick={() => startEdit(cat)} style={{
                      background: "transparent", border: `1px solid ${C.borderSoft}`, borderRadius: 8,
                      padding: "7px 11px", cursor: "pointer", color: C.text, fontSize: 13, fontWeight: 600
                    }}>
                      Uredi
                    </button>
                    <DeleteButton onClick={() => deleteCategory(cat)}/>
                  </div>
                </td>
              </tr>
            ))}
            {!pager.total && (
              <tr>
                <td colSpan={5} style={{ ...tdStyle, textAlign: "center", padding: 48, color: C.textMuted }}>
                  Nema kategorija
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pager {...pager} label="kategorija"/>
    </div>
  );
}


/* ══════════════════════════════════════════════════════════════════
   ADMIN: PERMISSIONS
══════════════════════════════════════════════════════════════════ */

function AdminAdmins({ openCreateSeed = 0 }) {
  const [admins, setAdmins] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [toast, setToast] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [f, setF] = useState({ id: "", email: "", password: "", name: "", company: "" });

  const flash = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3200); };
  const askConfirm = (msg, fn) => setConfirm({ msg, fn });
  const doConfirm = () => { confirm?.fn(); setConfirm(null); };

  const load = useCallback(async () => {
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/list-admins`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${session.access_token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({})
    });
    const result = await res.json();
    if (result.error) { flash("Greška: " + result.error, false); return; }
    setAdmins(result.admins || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (openCreateSeed > 0) {
      setEditing(null);
      setF({ id: "", email: "", password: "", name: "", company: "" });
      setOpen(true);
    }
  }, [openCreateSeed]);

  const add = async () => {
    if (!f.email || !f.password || !f.name) {
      flash("Email, lozinka i ime su obavezni.", false);
      return;
    }
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-admin`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: f.email, password: f.password, name: f.name, company: f.company }),
      }
    );
    const result = await res.json();
    if (result.error) { flash("Greška: " + result.error, false); return; }
    flash("Admin dodan");
    setF({ id: "", email: "", password: "", name: "", company: "" });
    setOpen(false);
    load();
  };

  const startEdit = (admin) => {
    setEditing(admin);
    setF({
      id: admin.id,
      email: admin.email || "",
      password: "",
      name: admin.name || "",
      company: admin.company || ""
    });
    setOpen(true);
    scrollAdminTop();
  };

  const saveEdit = async () => {
    if (!f.id || !f.email || !f.name) {
      flash("Email i ime su obavezni.", false);
      return;
    }
    const { data: { session } } = await supabase.auth.getSession();
    const res = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/update-admin`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: f.id, email: f.email, password: f.password, name: f.name, company: f.company }),
      }
    );
    const result = await res.json();
    if (result.error) { flash("Greška: " + result.error, false); return; }
    flash("Admin spremljen");
    setF({ id: "", email: "", password: "", name: "", company: "" });
    setEditing(null);
    setOpen(false);
    load();
  };

  const del = (id, name) => {
    askConfirm(`Obrisati admina "${name}"?`, async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/delete-admin`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: id }),
        }
      );
      const result = await res.json();
      if (result.error) { flash("Greška: " + result.error, false); return; }
      flash("Admin obrisan");
      load();
    });
  };

  const pager = usePagination(admins);

  return (
    <div className="page">
      {toast && <Toast {...toast}/>}
      {confirm && <ConfirmDialog msg={confirm.msg} onConfirm={doConfirm} onCancel={() => setConfirm(null)}/>}

      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: 36, flexWrap: "wrap", gap: 16,
      }}>
        <h2 className="t-title">Admini</h2>
        <AdminButton label="Dodaj admina" onClick={() => { setEditing(null); setF({ id: "", email: "", password: "", name: "", company: "" }); setOpen(o => !o); scrollAdminTop(); }}/>
      </div>

      {open && (
        <AdminCard title={editing ? "Uredi admina" : "Novi admin"} onClose={() => { setOpen(false); setEditing(null); }}>
          <AdminField label="Ime i prezime" v={f.name} set={v => setF(x => ({ ...x, name: v }))}/>
          <AdminField label="Tvrtka" v={f.company} set={v => setF(x => ({ ...x, company: v }))}/>
          <AdminField label="Email" type="email" v={f.email} set={v => setF(x => ({ ...x, email: v }))}/>
          <AdminField label={editing ? "Nova lozinka (ostavi prazno ako ne mijenjaš)" : "Lozinka"} type="password" v={f.password} set={v => setF(x => ({ ...x, password: v }))}/>
          <AdminSubmit label={editing ? "Spremi admina" : "Dodaj admina"} onClick={editing ? saveEdit : add}/>
        </AdminCard>
      )}

      <div style={{
        background: C.surface, borderRadius: 14, overflow: "hidden",
        boxShadow: `0 0 0 1px ${C.borderSoft}`,
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: C.hairline }}>
              <th style={thStyle}>Ime</th>
              <th style={thStyle}>Tvrtka</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}></th>
            </tr>
          </thead>
          <tbody>
            {pager.current.map(a => (
              <tr key={a.id} style={{ borderTop: `1px solid ${C.borderSoft}` }}>
                <td style={tdStyle}><span style={{ fontWeight: 500 }}>{a.name}</span></td>
                <td style={{ ...tdStyle, color: C.textMuted }}>{a.company || "—"}</td>
                <td style={{ ...tdStyle, color: C.textMuted }}>{a.email || "—"}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <button onClick={() => startEdit(a)} style={{
                      background: "transparent", border: `1px solid ${C.borderSoft}`, borderRadius: 8,
                      padding: "7px 11px", cursor: "pointer", color: C.text, fontSize: 13, fontWeight: 600
                    }}>
                      Uredi
                    </button>
                    <DeleteButton onClick={() => del(a.id, a.name)}/>
                  </div>
                </td>
              </tr>
            ))}
            {!pager.total && (
              <tr>
                <td colSpan={4} style={{ ...tdStyle, textAlign: "center", padding: 48, color: C.textMuted }}>
                  Nema admina
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pager {...pager} label="admina"/>

      <div style={{
        marginTop: 20, padding: "14px 18px",
        background: C.hairline, borderRadius: 10,
        fontSize: 13, color: C.textFaint,
      }}>
        Svaki admin ima puna prava. Zadnji admin se ne može obrisati.
      </div>
    </div>
  );
}



/* ── Shared admin UI ── */
function AdminButton({ label, onClick }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        display: "flex", alignItems: "center", gap: 7,
        background: h ? "#000" : C.btnPrimary, color: "#FFF",
        border: "none", borderRadius: 10, padding: "10px 18px",
        fontSize: 14, fontWeight: 500, cursor: "pointer",
        transition: "background .15s", whiteSpace: "nowrap",
      }}>
      <Plus size={16}/>{label}
    </button>
  );
}

function AdminCard({ children, onClose, title }) {
  return (
    <div style={{
      background: C.surface, borderRadius: 16, padding: 24, marginBottom: 24,
      boxShadow: `0 0 0 1px ${C.borderSoft}`, maxWidth: 460,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <span style={{ fontSize: 17, fontWeight: 600, color: C.text, letterSpacing: -.2 }}>{title}</span>
        <button onClick={onClose} style={{
          background: "none", border: "none", cursor: "pointer", color: C.textMuted,
          display: "flex", padding: 4, borderRadius: 6, transition: "color .15s",
        }}
        onMouseEnter={e => e.currentTarget.style.color = C.text}
        onMouseLeave={e => e.currentTarget.style.color = C.textMuted}>
          <X size={18}/>
        </button>
      </div>
      {children}
    </div>
  );
}

function AdminField({ label, v, set, type = "text", placeholder, autoComplete = "off", inputName }) {
  const [f, setF] = useState(false);
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={fieldLabel}>{label}</label>
      <input
        name={inputName}
        autoComplete={autoComplete}
        type={type}
        value={v}
        onChange={e => set(e.target.value)}
        placeholder={placeholder}
        onFocus={() => setF(true)}
        onBlur={() => setF(false)}
        style={{
          width: "100%", padding: "11px 13px",
          border: `1px solid ${f ? C.text : C.border}`,
          borderRadius: 10, fontSize: 14, boxSizing: "border-box",
          outline: "none", transition: "border-color .15s",
          color: C.text, background: C.surface, fontFamily: "inherit",
        }}/>
    </div>
  );
}

function PasswordField({ label, value, set }) {
  const [f, setF] = useState(false);
  const [copied, setCopied] = useState(false);
  const pwBtnStyle = {
    background: C.btnPrimary, color: "#FFF", border: "none",
    borderRadius: 10, padding: "0 14px", fontSize: 13, fontWeight: 500,
    cursor: "pointer", whiteSpace: "nowrap",
  };
  const copy = async () => {
    if (!value) return;
    try { await navigator.clipboard.writeText(value); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch (e) {}
  };
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={fieldLabel}>{label}</label>
      <div style={{ display: "flex", gap: 8 }}>
        <input
          name="customer_password"
          autoComplete="new-password"
          type="text"
          value={value}
          onChange={e => set(e.target.value)}
          placeholder="Kliknite Generiraj ili upišite"
          onFocus={() => setF(true)}
          onBlur={() => setF(false)}
          style={{
            flex: 1, minWidth: 0, padding: "11px 13px",
            border: `1px solid ${f ? C.text : C.border}`,
            borderRadius: 10, fontSize: 14, boxSizing: "border-box",
            outline: "none", transition: "border-color .15s",
            color: C.text, background: C.surface,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
          }}/>
        <button type="button" onClick={() => set(generatePassword())} style={pwBtnStyle}>Generiraj</button>
        <button type="button" onClick={copy} style={{ ...pwBtnStyle, minWidth: 80 }}>{copied ? "Kopirano" : "Kopiraj"}</button>
      </div>
      <div style={{ fontSize: 12, color: C.textMuted, marginTop: 6 }}>
        Lozinku proslijedite kupcu — prijavljuje se s imenom firme i ovom lozinkom.
      </div>
    </div>
  );
}

function AdminSubmit({ label, onClick }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        background: h ? "#000" : C.btnPrimary, color: "#FFF",
        border: "none", borderRadius: 10, padding: "12px 20px",
        fontSize: 14, fontWeight: 500, cursor: "pointer",
        width: "100%", transition: "background .15s",
      }}>
      {label}
    </button>
  );
}

function DeleteButton({ onClick }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        background: h ? C.dangerBg : "transparent",
        border: "none", cursor: "pointer",
        color: h ? C.danger : C.textMuted,
        padding: 7, borderRadius: 8, display: "flex",
        transition: "all .15s",
      }}>
      <Trash2 size={15}/>
    </button>
  );
}

const thStyle = {
  padding: "14px 18px", textAlign: "left",
  fontSize: 11, fontWeight: 600, color: C.textMuted,
  letterSpacing: .8, textTransform: "uppercase",
};
const tdStyle = { padding: "16px 18px", fontSize: 14, color: C.text };
const fieldLabel = {
  display: "block", fontSize: 13, fontWeight: 500,
  color: C.text, marginBottom: 8,
};
const selectStyle = {
  width: "100%", padding: "11px 13px",
  border: `1px solid ${C.border}`, borderRadius: 10,
  fontSize: 14, background: C.surface, color: C.text,
  outline: "none", fontFamily: "inherit",
};
